var Hn = Object.defineProperty;
var Gn = (i, r, e) => r in i ? Hn(i, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[r] = e;
var g = (i, r, e) => Gn(i, typeof r != "symbol" ? r + "" : r, e);
function kr(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var mt = { exports: {} }, $ = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lr;
function Xn() {
  if (lr) return $;
  lr = 1;
  var i = Symbol.for("react.element"), r = Symbol.for("react.portal"), e = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), l = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), w = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), T = Symbol.iterator;
  function I(s) {
    return s === null || typeof s != "object" ? null : (s = T && s[T] || s["@@iterator"], typeof s == "function" ? s : null);
  }
  var j = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, F = Object.assign, z = {};
  function W(s, d, E) {
    this.props = s, this.context = d, this.refs = z, this.updater = E || j;
  }
  W.prototype.isReactComponent = {}, W.prototype.setState = function(s, d) {
    if (typeof s != "object" && typeof s != "function" && s != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, s, d, "setState");
  }, W.prototype.forceUpdate = function(s) {
    this.updater.enqueueForceUpdate(this, s, "forceUpdate");
  };
  function B() {
  }
  B.prototype = W.prototype;
  function se(s, d, E) {
    this.props = s, this.context = d, this.refs = z, this.updater = E || j;
  }
  var G = se.prototype = new B();
  G.constructor = se, F(G, W.prototype), G.isPureReactComponent = !0;
  var Y = Array.isArray, y = Object.prototype.hasOwnProperty, Z = { current: null }, ce = { key: !0, ref: !0, __self: !0, __source: !0 };
  function fe(s, d, E) {
    var _, C = {}, O = null, P = null;
    if (d != null) for (_ in d.ref !== void 0 && (P = d.ref), d.key !== void 0 && (O = "" + d.key), d) y.call(d, _) && !ce.hasOwnProperty(_) && (C[_] = d[_]);
    var M = arguments.length - 2;
    if (M === 1) C.children = E;
    else if (1 < M) {
      for (var D = Array(M), A = 0; A < M; A++) D[A] = arguments[A + 2];
      C.children = D;
    }
    if (s && s.defaultProps) for (_ in M = s.defaultProps, M) C[_] === void 0 && (C[_] = M[_]);
    return { $$typeof: i, type: s, key: O, ref: P, props: C, _owner: Z.current };
  }
  function pe(s, d) {
    return { $$typeof: i, type: s.type, key: d, ref: s.ref, props: s.props, _owner: s._owner };
  }
  function he(s) {
    return typeof s == "object" && s !== null && s.$$typeof === i;
  }
  function ve(s) {
    var d = { "=": "=0", ":": "=2" };
    return "$" + s.replace(/[=:]/g, function(E) {
      return d[E];
    });
  }
  var ye = /\/+/g;
  function de(s, d) {
    return typeof s == "object" && s !== null && s.key != null ? ve("" + s.key) : d.toString(36);
  }
  function ue(s, d, E, _, C) {
    var O = typeof s;
    (O === "undefined" || O === "boolean") && (s = null);
    var P = !1;
    if (s === null) P = !0;
    else switch (O) {
      case "string":
      case "number":
        P = !0;
        break;
      case "object":
        switch (s.$$typeof) {
          case i:
          case r:
            P = !0;
        }
    }
    if (P) return P = s, C = C(P), s = _ === "" ? "." + de(P, 0) : _, Y(C) ? (E = "", s != null && (E = s.replace(ye, "$&/") + "/"), ue(C, d, E, "", function(A) {
      return A;
    })) : C != null && (he(C) && (C = pe(C, E + (!C.key || P && P.key === C.key ? "" : ("" + C.key).replace(ye, "$&/") + "/") + s)), d.push(C)), 1;
    if (P = 0, _ = _ === "" ? "." : _ + ":", Y(s)) for (var M = 0; M < s.length; M++) {
      O = s[M];
      var D = _ + de(O, M);
      P += ue(O, d, E, D, C);
    }
    else if (D = I(s), typeof D == "function") for (s = D.call(s), M = 0; !(O = s.next()).done; ) O = O.value, D = _ + de(O, M++), P += ue(O, d, E, D, C);
    else if (O === "object") throw d = String(s), Error("Objects are not valid as a React child (found: " + (d === "[object Object]" ? "object with keys {" + Object.keys(s).join(", ") + "}" : d) + "). If you meant to render a collection of children, use an array instead.");
    return P;
  }
  function ie(s, d, E) {
    if (s == null) return s;
    var _ = [], C = 0;
    return ue(s, _, "", "", function(O) {
      return d.call(E, O, C++);
    }), _;
  }
  function ee(s) {
    if (s._status === -1) {
      var d = s._result;
      d = d(), d.then(function(E) {
        (s._status === 0 || s._status === -1) && (s._status = 1, s._result = E);
      }, function(E) {
        (s._status === 0 || s._status === -1) && (s._status = 2, s._result = E);
      }), s._status === -1 && (s._status = 0, s._result = d);
    }
    if (s._status === 1) return s._result.default;
    throw s._result;
  }
  var x = { current: null }, le = { transition: null }, me = { ReactCurrentDispatcher: x, ReactCurrentBatchConfig: le, ReactCurrentOwner: Z };
  function p() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return $.Children = { map: ie, forEach: function(s, d, E) {
    ie(s, function() {
      d.apply(this, arguments);
    }, E);
  }, count: function(s) {
    var d = 0;
    return ie(s, function() {
      d++;
    }), d;
  }, toArray: function(s) {
    return ie(s, function(d) {
      return d;
    }) || [];
  }, only: function(s) {
    if (!he(s)) throw Error("React.Children.only expected to receive a single React element child.");
    return s;
  } }, $.Component = W, $.Fragment = e, $.Profiler = o, $.PureComponent = se, $.StrictMode = n, $.Suspense = v, $.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = me, $.act = p, $.cloneElement = function(s, d, E) {
    if (s == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + s + ".");
    var _ = F({}, s.props), C = s.key, O = s.ref, P = s._owner;
    if (d != null) {
      if (d.ref !== void 0 && (O = d.ref, P = Z.current), d.key !== void 0 && (C = "" + d.key), s.type && s.type.defaultProps) var M = s.type.defaultProps;
      for (D in d) y.call(d, D) && !ce.hasOwnProperty(D) && (_[D] = d[D] === void 0 && M !== void 0 ? M[D] : d[D]);
    }
    var D = arguments.length - 2;
    if (D === 1) _.children = E;
    else if (1 < D) {
      M = Array(D);
      for (var A = 0; A < D; A++) M[A] = arguments[A + 2];
      _.children = M;
    }
    return { $$typeof: i, type: s.type, key: C, ref: O, props: _, _owner: P };
  }, $.createContext = function(s) {
    return s = { $$typeof: l, _currentValue: s, _currentValue2: s, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, s.Provider = { $$typeof: u, _context: s }, s.Consumer = s;
  }, $.createElement = fe, $.createFactory = function(s) {
    var d = fe.bind(null, s);
    return d.type = s, d;
  }, $.createRef = function() {
    return { current: null };
  }, $.forwardRef = function(s) {
    return { $$typeof: f, render: s };
  }, $.isValidElement = he, $.lazy = function(s) {
    return { $$typeof: b, _payload: { _status: -1, _result: s }, _init: ee };
  }, $.memo = function(s, d) {
    return { $$typeof: w, type: s, compare: d === void 0 ? null : d };
  }, $.startTransition = function(s) {
    var d = le.transition;
    le.transition = {};
    try {
      s();
    } finally {
      le.transition = d;
    }
  }, $.unstable_act = p, $.useCallback = function(s, d) {
    return x.current.useCallback(s, d);
  }, $.useContext = function(s) {
    return x.current.useContext(s);
  }, $.useDebugValue = function() {
  }, $.useDeferredValue = function(s) {
    return x.current.useDeferredValue(s);
  }, $.useEffect = function(s, d) {
    return x.current.useEffect(s, d);
  }, $.useId = function() {
    return x.current.useId();
  }, $.useImperativeHandle = function(s, d, E) {
    return x.current.useImperativeHandle(s, d, E);
  }, $.useInsertionEffect = function(s, d) {
    return x.current.useInsertionEffect(s, d);
  }, $.useLayoutEffect = function(s, d) {
    return x.current.useLayoutEffect(s, d);
  }, $.useMemo = function(s, d) {
    return x.current.useMemo(s, d);
  }, $.useReducer = function(s, d, E) {
    return x.current.useReducer(s, d, E);
  }, $.useRef = function(s) {
    return x.current.useRef(s);
  }, $.useState = function(s) {
    return x.current.useState(s);
  }, $.useSyncExternalStore = function(s, d, E) {
    return x.current.useSyncExternalStore(s, d, E);
  }, $.useTransition = function() {
    return x.current.useTransition();
  }, $.version = "18.3.1", $;
}
var De = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
De.exports;
var fr;
function Kn() {
  return fr || (fr = 1, function(i, r) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = "18.3.1", n = Symbol.for("react.element"), o = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), v = Symbol.for("react.provider"), w = Symbol.for("react.context"), b = Symbol.for("react.forward_ref"), T = Symbol.for("react.suspense"), I = Symbol.for("react.suspense_list"), j = Symbol.for("react.memo"), F = Symbol.for("react.lazy"), z = Symbol.for("react.offscreen"), W = Symbol.iterator, B = "@@iterator";
      function se(t) {
        if (t === null || typeof t != "object")
          return null;
        var a = W && t[W] || t[B];
        return typeof a == "function" ? a : null;
      }
      var G = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, Y = {
        transition: null
      }, y = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, Z = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, ce = {}, fe = null;
      function pe(t) {
        fe = t;
      }
      ce.setExtraStackFrame = function(t) {
        fe = t;
      }, ce.getCurrentStack = null, ce.getStackAddendum = function() {
        var t = "";
        fe && (t += fe);
        var a = ce.getCurrentStack;
        return a && (t += a() || ""), t;
      };
      var he = !1, ve = !1, ye = !1, de = !1, ue = !1, ie = {
        ReactCurrentDispatcher: G,
        ReactCurrentBatchConfig: Y,
        ReactCurrentOwner: Z
      };
      ie.ReactDebugCurrentFrame = ce, ie.ReactCurrentActQueue = y;
      function ee(t) {
        {
          for (var a = arguments.length, c = new Array(a > 1 ? a - 1 : 0), h = 1; h < a; h++)
            c[h - 1] = arguments[h];
          le("warn", t, c);
        }
      }
      function x(t) {
        {
          for (var a = arguments.length, c = new Array(a > 1 ? a - 1 : 0), h = 1; h < a; h++)
            c[h - 1] = arguments[h];
          le("error", t, c);
        }
      }
      function le(t, a, c) {
        {
          var h = ie.ReactDebugCurrentFrame, m = h.getStackAddendum();
          m !== "" && (a += "%s", c = c.concat([m]));
          var k = c.map(function(R) {
            return String(R);
          });
          k.unshift("Warning: " + a), Function.prototype.apply.call(console[t], console, k);
        }
      }
      var me = {};
      function p(t, a) {
        {
          var c = t.constructor, h = c && (c.displayName || c.name) || "ReactClass", m = h + "." + a;
          if (me[m])
            return;
          x("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", a, h), me[m] = !0;
        }
      }
      var s = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(t) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(t, a, c) {
          p(t, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(t, a, c, h) {
          p(t, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(t, a, c, h) {
          p(t, "setState");
        }
      }, d = Object.assign, E = {};
      Object.freeze(E);
      function _(t, a, c) {
        this.props = t, this.context = a, this.refs = E, this.updater = c || s;
      }
      _.prototype.isReactComponent = {}, _.prototype.setState = function(t, a) {
        if (typeof t != "object" && typeof t != "function" && t != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, t, a, "setState");
      }, _.prototype.forceUpdate = function(t) {
        this.updater.enqueueForceUpdate(this, t, "forceUpdate");
      };
      {
        var C = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, O = function(t, a) {
          Object.defineProperty(_.prototype, t, {
            get: function() {
              ee("%s(...) is deprecated in plain JavaScript React classes. %s", a[0], a[1]);
            }
          });
        };
        for (var P in C)
          C.hasOwnProperty(P) && O(P, C[P]);
      }
      function M() {
      }
      M.prototype = _.prototype;
      function D(t, a, c) {
        this.props = t, this.context = a, this.refs = E, this.updater = c || s;
      }
      var A = D.prototype = new M();
      A.constructor = D, d(A, _.prototype), A.isPureReactComponent = !0;
      function ne() {
        var t = {
          current: null
        };
        return Object.seal(t), t;
      }
      var S = Array.isArray;
      function ae(t) {
        return S(t);
      }
      function we(t) {
        {
          var a = typeof Symbol == "function" && Symbol.toStringTag, c = a && t[Symbol.toStringTag] || t.constructor.name || "Object";
          return c;
        }
      }
      function Ae(t) {
        try {
          return Ot(t), !1;
        } catch {
          return !0;
        }
      }
      function Ot(t) {
        return "" + t;
      }
      function Le(t) {
        if (Ae(t))
          return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", we(t)), Ot(t);
      }
      function Nr(t, a, c) {
        var h = t.displayName;
        if (h)
          return h;
        var m = a.displayName || a.name || "";
        return m !== "" ? c + "(" + m + ")" : c;
      }
      function Pt(t) {
        return t.displayName || "Context";
      }
      function ge(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case u:
            return "Fragment";
          case o:
            return "Portal";
          case f:
            return "Profiler";
          case l:
            return "StrictMode";
          case T:
            return "Suspense";
          case I:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case w:
              var a = t;
              return Pt(a) + ".Consumer";
            case v:
              var c = t;
              return Pt(c._context) + ".Provider";
            case b:
              return Nr(t, t.render, "ForwardRef");
            case j:
              var h = t.displayName || null;
              return h !== null ? h : ge(t.type) || "Memo";
            case F: {
              var m = t, k = m._payload, R = m._init;
              try {
                return ge(R(k));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Pe = Object.prototype.hasOwnProperty, xt = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Mt, Dt, Ze;
      Ze = {};
      function kt(t) {
        if (Pe.call(t, "ref")) {
          var a = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function At(t) {
        if (Pe.call(t, "key")) {
          var a = Object.getOwnPropertyDescriptor(t, "key").get;
          if (a && a.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function Ur(t, a) {
        var c = function() {
          Mt || (Mt = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        c.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: c,
          configurable: !0
        });
      }
      function Br(t, a) {
        var c = function() {
          Dt || (Dt = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        c.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: c,
          configurable: !0
        });
      }
      function Hr(t) {
        if (typeof t.ref == "string" && Z.current && t.__self && Z.current.stateNode !== t.__self) {
          var a = ge(Z.current.type);
          Ze[a] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', a, t.ref), Ze[a] = !0);
        }
      }
      var Qe = function(t, a, c, h, m, k, R) {
        var L = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: t,
          key: a,
          ref: c,
          props: R,
          // Record the component responsible for creating this element.
          _owner: k
        };
        return L._store = {}, Object.defineProperty(L._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(L, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: h
        }), Object.defineProperty(L, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: m
        }), Object.freeze && (Object.freeze(L.props), Object.freeze(L)), L;
      };
      function Gr(t, a, c) {
        var h, m = {}, k = null, R = null, L = null, V = null;
        if (a != null) {
          kt(a) && (R = a.ref, Hr(a)), At(a) && (Le(a.key), k = "" + a.key), L = a.__self === void 0 ? null : a.__self, V = a.__source === void 0 ? null : a.__source;
          for (h in a)
            Pe.call(a, h) && !xt.hasOwnProperty(h) && (m[h] = a[h]);
        }
        var H = arguments.length - 2;
        if (H === 1)
          m.children = c;
        else if (H > 1) {
          for (var X = Array(H), K = 0; K < H; K++)
            X[K] = arguments[K + 2];
          Object.freeze && Object.freeze(X), m.children = X;
        }
        if (t && t.defaultProps) {
          var J = t.defaultProps;
          for (h in J)
            m[h] === void 0 && (m[h] = J[h]);
        }
        if (k || R) {
          var Q = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          k && Ur(m, Q), R && Br(m, Q);
        }
        return Qe(t, k, R, L, V, Z.current, m);
      }
      function Xr(t, a) {
        var c = Qe(t.type, a, t.ref, t._self, t._source, t._owner, t.props);
        return c;
      }
      function Kr(t, a, c) {
        if (t == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + t + ".");
        var h, m = d({}, t.props), k = t.key, R = t.ref, L = t._self, V = t._source, H = t._owner;
        if (a != null) {
          kt(a) && (R = a.ref, H = Z.current), At(a) && (Le(a.key), k = "" + a.key);
          var X;
          t.type && t.type.defaultProps && (X = t.type.defaultProps);
          for (h in a)
            Pe.call(a, h) && !xt.hasOwnProperty(h) && (a[h] === void 0 && X !== void 0 ? m[h] = X[h] : m[h] = a[h]);
        }
        var K = arguments.length - 2;
        if (K === 1)
          m.children = c;
        else if (K > 1) {
          for (var J = Array(K), Q = 0; Q < K; Q++)
            J[Q] = arguments[Q + 2];
          m.children = J;
        }
        return Qe(t.type, k, R, L, V, H, m);
      }
      function Ee(t) {
        return typeof t == "object" && t !== null && t.$$typeof === n;
      }
      var Lt = ".", Jr = ":";
      function Zr(t) {
        var a = /[=:]/g, c = {
          "=": "=0",
          ":": "=2"
        }, h = t.replace(a, function(m) {
          return c[m];
        });
        return "$" + h;
      }
      var It = !1, Qr = /\/+/g;
      function jt(t) {
        return t.replace(Qr, "$&/");
      }
      function et(t, a) {
        return typeof t == "object" && t !== null && t.key != null ? (Le(t.key), Zr("" + t.key)) : a.toString(36);
      }
      function Ie(t, a, c, h, m) {
        var k = typeof t;
        (k === "undefined" || k === "boolean") && (t = null);
        var R = !1;
        if (t === null)
          R = !0;
        else
          switch (k) {
            case "string":
            case "number":
              R = !0;
              break;
            case "object":
              switch (t.$$typeof) {
                case n:
                case o:
                  R = !0;
              }
          }
        if (R) {
          var L = t, V = m(L), H = h === "" ? Lt + et(L, 0) : h;
          if (ae(V)) {
            var X = "";
            H != null && (X = jt(H) + "/"), Ie(V, a, X, "", function(Bn) {
              return Bn;
            });
          } else V != null && (Ee(V) && (V.key && (!L || L.key !== V.key) && Le(V.key), V = Xr(
            V,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            c + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (V.key && (!L || L.key !== V.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              jt("" + V.key) + "/"
            ) : "") + H
          )), a.push(V));
          return 1;
        }
        var K, J, Q = 0, re = h === "" ? Lt : h + Jr;
        if (ae(t))
          for (var qe = 0; qe < t.length; qe++)
            K = t[qe], J = re + et(K, qe), Q += Ie(K, a, c, J, m);
        else {
          var ct = se(t);
          if (typeof ct == "function") {
            var sr = t;
            ct === sr.entries && (It || ee("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), It = !0);
            for (var Nn = ct.call(sr), ur, Un = 0; !(ur = Nn.next()).done; )
              K = ur.value, J = re + et(K, Un++), Q += Ie(K, a, c, J, m);
          } else if (k === "object") {
            var cr = String(t);
            throw new Error("Objects are not valid as a React child (found: " + (cr === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : cr) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return Q;
      }
      function je(t, a, c) {
        if (t == null)
          return t;
        var h = [], m = 0;
        return Ie(t, h, "", "", function(k) {
          return a.call(c, k, m++);
        }), h;
      }
      function en(t) {
        var a = 0;
        return je(t, function() {
          a++;
        }), a;
      }
      function tn(t, a, c) {
        je(t, function() {
          a.apply(this, arguments);
        }, c);
      }
      function rn(t) {
        return je(t, function(a) {
          return a;
        }) || [];
      }
      function nn(t) {
        if (!Ee(t))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return t;
      }
      function an(t) {
        var a = {
          $$typeof: w,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: t,
          _currentValue2: t,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        a.Provider = {
          $$typeof: v,
          _context: a
        };
        var c = !1, h = !1, m = !1;
        {
          var k = {
            $$typeof: w,
            _context: a
          };
          Object.defineProperties(k, {
            Provider: {
              get: function() {
                return h || (h = !0, x("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), a.Provider;
              },
              set: function(R) {
                a.Provider = R;
              }
            },
            _currentValue: {
              get: function() {
                return a._currentValue;
              },
              set: function(R) {
                a._currentValue = R;
              }
            },
            _currentValue2: {
              get: function() {
                return a._currentValue2;
              },
              set: function(R) {
                a._currentValue2 = R;
              }
            },
            _threadCount: {
              get: function() {
                return a._threadCount;
              },
              set: function(R) {
                a._threadCount = R;
              }
            },
            Consumer: {
              get: function() {
                return c || (c = !0, x("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), a.Consumer;
              }
            },
            displayName: {
              get: function() {
                return a.displayName;
              },
              set: function(R) {
                m || (ee("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", R), m = !0);
              }
            }
          }), a.Consumer = k;
        }
        return a._currentRenderer = null, a._currentRenderer2 = null, a;
      }
      var xe = -1, tt = 0, zt = 1, on = 2;
      function sn(t) {
        if (t._status === xe) {
          var a = t._result, c = a();
          if (c.then(function(k) {
            if (t._status === tt || t._status === xe) {
              var R = t;
              R._status = zt, R._result = k;
            }
          }, function(k) {
            if (t._status === tt || t._status === xe) {
              var R = t;
              R._status = on, R._result = k;
            }
          }), t._status === xe) {
            var h = t;
            h._status = tt, h._result = c;
          }
        }
        if (t._status === zt) {
          var m = t._result;
          return m === void 0 && x(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, m), "default" in m || x(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, m), m.default;
        } else
          throw t._result;
      }
      function un(t) {
        var a = {
          // We use these fields to store the result.
          _status: xe,
          _result: t
        }, c = {
          $$typeof: F,
          _payload: a,
          _init: sn
        };
        {
          var h, m;
          Object.defineProperties(c, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return h;
              },
              set: function(k) {
                x("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), h = k, Object.defineProperty(c, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return m;
              },
              set: function(k) {
                x("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), m = k, Object.defineProperty(c, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return c;
      }
      function cn(t) {
        t != null && t.$$typeof === j ? x("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof t != "function" ? x("forwardRef requires a render function but was given %s.", t === null ? "null" : typeof t) : t.length !== 0 && t.length !== 2 && x("forwardRef render functions accept exactly two parameters: props and ref. %s", t.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), t != null && (t.defaultProps != null || t.propTypes != null) && x("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var a = {
          $$typeof: b,
          render: t
        };
        {
          var c;
          Object.defineProperty(a, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return c;
            },
            set: function(h) {
              c = h, !t.name && !t.displayName && (t.displayName = h);
            }
          });
        }
        return a;
      }
      var $t;
      $t = Symbol.for("react.module.reference");
      function Wt(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === u || t === f || ue || t === l || t === T || t === I || de || t === z || he || ve || ye || typeof t == "object" && t !== null && (t.$$typeof === F || t.$$typeof === j || t.$$typeof === v || t.$$typeof === w || t.$$typeof === b || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        t.$$typeof === $t || t.getModuleId !== void 0));
      }
      function ln(t, a) {
        Wt(t) || x("memo: The first argument must be a component. Instead received: %s", t === null ? "null" : typeof t);
        var c = {
          $$typeof: j,
          type: t,
          compare: a === void 0 ? null : a
        };
        {
          var h;
          Object.defineProperty(c, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return h;
            },
            set: function(m) {
              h = m, !t.name && !t.displayName && (t.displayName = m);
            }
          });
        }
        return c;
      }
      function oe() {
        var t = G.current;
        return t === null && x(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), t;
      }
      function fn(t) {
        var a = oe();
        if (t._context !== void 0) {
          var c = t._context;
          c.Consumer === t ? x("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : c.Provider === t && x("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return a.useContext(t);
      }
      function hn(t) {
        var a = oe();
        return a.useState(t);
      }
      function dn(t, a, c) {
        var h = oe();
        return h.useReducer(t, a, c);
      }
      function pn(t) {
        var a = oe();
        return a.useRef(t);
      }
      function vn(t, a) {
        var c = oe();
        return c.useEffect(t, a);
      }
      function yn(t, a) {
        var c = oe();
        return c.useInsertionEffect(t, a);
      }
      function mn(t, a) {
        var c = oe();
        return c.useLayoutEffect(t, a);
      }
      function gn(t, a) {
        var c = oe();
        return c.useCallback(t, a);
      }
      function bn(t, a) {
        var c = oe();
        return c.useMemo(t, a);
      }
      function _n(t, a, c) {
        var h = oe();
        return h.useImperativeHandle(t, a, c);
      }
      function wn(t, a) {
        {
          var c = oe();
          return c.useDebugValue(t, a);
        }
      }
      function En() {
        var t = oe();
        return t.useTransition();
      }
      function Sn(t) {
        var a = oe();
        return a.useDeferredValue(t);
      }
      function Cn() {
        var t = oe();
        return t.useId();
      }
      function Rn(t, a, c) {
        var h = oe();
        return h.useSyncExternalStore(t, a, c);
      }
      var Me = 0, Vt, Ft, Yt, qt, Nt, Ut, Bt;
      function Ht() {
      }
      Ht.__reactDisabledLog = !0;
      function Tn() {
        {
          if (Me === 0) {
            Vt = console.log, Ft = console.info, Yt = console.warn, qt = console.error, Nt = console.group, Ut = console.groupCollapsed, Bt = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: Ht,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          Me++;
        }
      }
      function On() {
        {
          if (Me--, Me === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: d({}, t, {
                value: Vt
              }),
              info: d({}, t, {
                value: Ft
              }),
              warn: d({}, t, {
                value: Yt
              }),
              error: d({}, t, {
                value: qt
              }),
              group: d({}, t, {
                value: Nt
              }),
              groupCollapsed: d({}, t, {
                value: Ut
              }),
              groupEnd: d({}, t, {
                value: Bt
              })
            });
          }
          Me < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var rt = ie.ReactCurrentDispatcher, nt;
      function ze(t, a, c) {
        {
          if (nt === void 0)
            try {
              throw Error();
            } catch (m) {
              var h = m.stack.trim().match(/\n( *(at )?)/);
              nt = h && h[1] || "";
            }
          return `
` + nt + t;
        }
      }
      var it = !1, $e;
      {
        var Pn = typeof WeakMap == "function" ? WeakMap : Map;
        $e = new Pn();
      }
      function Gt(t, a) {
        if (!t || it)
          return "";
        {
          var c = $e.get(t);
          if (c !== void 0)
            return c;
        }
        var h;
        it = !0;
        var m = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var k;
        k = rt.current, rt.current = null, Tn();
        try {
          if (a) {
            var R = function() {
              throw Error();
            };
            if (Object.defineProperty(R.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(R, []);
              } catch (re) {
                h = re;
              }
              Reflect.construct(t, [], R);
            } else {
              try {
                R.call();
              } catch (re) {
                h = re;
              }
              t.call(R.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (re) {
              h = re;
            }
            t();
          }
        } catch (re) {
          if (re && h && typeof re.stack == "string") {
            for (var L = re.stack.split(`
`), V = h.stack.split(`
`), H = L.length - 1, X = V.length - 1; H >= 1 && X >= 0 && L[H] !== V[X]; )
              X--;
            for (; H >= 1 && X >= 0; H--, X--)
              if (L[H] !== V[X]) {
                if (H !== 1 || X !== 1)
                  do
                    if (H--, X--, X < 0 || L[H] !== V[X]) {
                      var K = `
` + L[H].replace(" at new ", " at ");
                      return t.displayName && K.includes("<anonymous>") && (K = K.replace("<anonymous>", t.displayName)), typeof t == "function" && $e.set(t, K), K;
                    }
                  while (H >= 1 && X >= 0);
                break;
              }
          }
        } finally {
          it = !1, rt.current = k, On(), Error.prepareStackTrace = m;
        }
        var J = t ? t.displayName || t.name : "", Q = J ? ze(J) : "";
        return typeof t == "function" && $e.set(t, Q), Q;
      }
      function xn(t, a, c) {
        return Gt(t, !1);
      }
      function Mn(t) {
        var a = t.prototype;
        return !!(a && a.isReactComponent);
      }
      function We(t, a, c) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return Gt(t, Mn(t));
        if (typeof t == "string")
          return ze(t);
        switch (t) {
          case T:
            return ze("Suspense");
          case I:
            return ze("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case b:
              return xn(t.render);
            case j:
              return We(t.type, a, c);
            case F: {
              var h = t, m = h._payload, k = h._init;
              try {
                return We(k(m), a, c);
              } catch {
              }
            }
          }
        return "";
      }
      var Xt = {}, Kt = ie.ReactDebugCurrentFrame;
      function Ve(t) {
        if (t) {
          var a = t._owner, c = We(t.type, t._source, a ? a.type : null);
          Kt.setExtraStackFrame(c);
        } else
          Kt.setExtraStackFrame(null);
      }
      function Dn(t, a, c, h, m) {
        {
          var k = Function.call.bind(Pe);
          for (var R in t)
            if (k(t, R)) {
              var L = void 0;
              try {
                if (typeof t[R] != "function") {
                  var V = Error((h || "React class") + ": " + c + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw V.name = "Invariant Violation", V;
                }
                L = t[R](a, R, h, c, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (H) {
                L = H;
              }
              L && !(L instanceof Error) && (Ve(m), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", h || "React class", c, R, typeof L), Ve(null)), L instanceof Error && !(L.message in Xt) && (Xt[L.message] = !0, Ve(m), x("Failed %s type: %s", c, L.message), Ve(null));
            }
        }
      }
      function Se(t) {
        if (t) {
          var a = t._owner, c = We(t.type, t._source, a ? a.type : null);
          pe(c);
        } else
          pe(null);
      }
      var at;
      at = !1;
      function Jt() {
        if (Z.current) {
          var t = ge(Z.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
      function kn(t) {
        if (t !== void 0) {
          var a = t.fileName.replace(/^.*[\\\/]/, ""), c = t.lineNumber;
          return `

Check your code at ` + a + ":" + c + ".";
        }
        return "";
      }
      function An(t) {
        return t != null ? kn(t.__source) : "";
      }
      var Zt = {};
      function Ln(t) {
        var a = Jt();
        if (!a) {
          var c = typeof t == "string" ? t : t.displayName || t.name;
          c && (a = `

Check the top-level render call using <` + c + ">.");
        }
        return a;
      }
      function Qt(t, a) {
        if (!(!t._store || t._store.validated || t.key != null)) {
          t._store.validated = !0;
          var c = Ln(a);
          if (!Zt[c]) {
            Zt[c] = !0;
            var h = "";
            t && t._owner && t._owner !== Z.current && (h = " It was passed a child from " + ge(t._owner.type) + "."), Se(t), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', c, h), Se(null);
          }
        }
      }
      function er(t, a) {
        if (typeof t == "object") {
          if (ae(t))
            for (var c = 0; c < t.length; c++) {
              var h = t[c];
              Ee(h) && Qt(h, a);
            }
          else if (Ee(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var m = se(t);
            if (typeof m == "function" && m !== t.entries)
              for (var k = m.call(t), R; !(R = k.next()).done; )
                Ee(R.value) && Qt(R.value, a);
          }
        }
      }
      function tr(t) {
        {
          var a = t.type;
          if (a == null || typeof a == "string")
            return;
          var c;
          if (typeof a == "function")
            c = a.propTypes;
          else if (typeof a == "object" && (a.$$typeof === b || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          a.$$typeof === j))
            c = a.propTypes;
          else
            return;
          if (c) {
            var h = ge(a);
            Dn(c, t.props, "prop", h, t);
          } else if (a.PropTypes !== void 0 && !at) {
            at = !0;
            var m = ge(a);
            x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", m || "Unknown");
          }
          typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function In(t) {
        {
          for (var a = Object.keys(t.props), c = 0; c < a.length; c++) {
            var h = a[c];
            if (h !== "children" && h !== "key") {
              Se(t), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", h), Se(null);
              break;
            }
          }
          t.ref !== null && (Se(t), x("Invalid attribute `ref` supplied to `React.Fragment`."), Se(null));
        }
      }
      function rr(t, a, c) {
        var h = Wt(t);
        if (!h) {
          var m = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (m += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var k = An(a);
          k ? m += k : m += Jt();
          var R;
          t === null ? R = "null" : ae(t) ? R = "array" : t !== void 0 && t.$$typeof === n ? (R = "<" + (ge(t.type) || "Unknown") + " />", m = " Did you accidentally export a JSX literal instead of a component?") : R = typeof t, x("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", R, m);
        }
        var L = Gr.apply(this, arguments);
        if (L == null)
          return L;
        if (h)
          for (var V = 2; V < arguments.length; V++)
            er(arguments[V], t);
        return t === u ? In(L) : tr(L), L;
      }
      var nr = !1;
      function jn(t) {
        var a = rr.bind(null, t);
        return a.type = t, nr || (nr = !0, ee("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(a, "type", {
          enumerable: !1,
          get: function() {
            return ee("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: t
            }), t;
          }
        }), a;
      }
      function zn(t, a, c) {
        for (var h = Kr.apply(this, arguments), m = 2; m < arguments.length; m++)
          er(arguments[m], h.type);
        return tr(h), h;
      }
      function $n(t, a) {
        var c = Y.transition;
        Y.transition = {};
        var h = Y.transition;
        Y.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          t();
        } finally {
          if (Y.transition = c, c === null && h._updatedFibers) {
            var m = h._updatedFibers.size;
            m > 10 && ee("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), h._updatedFibers.clear();
          }
        }
      }
      var ir = !1, Fe = null;
      function Wn(t) {
        if (Fe === null)
          try {
            var a = ("require" + Math.random()).slice(0, 7), c = i && i[a];
            Fe = c.call(i, "timers").setImmediate;
          } catch {
            Fe = function(m) {
              ir === !1 && (ir = !0, typeof MessageChannel > "u" && x("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var k = new MessageChannel();
              k.port1.onmessage = m, k.port2.postMessage(void 0);
            };
          }
        return Fe(t);
      }
      var Ce = 0, ar = !1;
      function or(t) {
        {
          var a = Ce;
          Ce++, y.current === null && (y.current = []);
          var c = y.isBatchingLegacy, h;
          try {
            if (y.isBatchingLegacy = !0, h = t(), !c && y.didScheduleLegacyUpdate) {
              var m = y.current;
              m !== null && (y.didScheduleLegacyUpdate = !1, ut(m));
            }
          } catch (J) {
            throw Ye(a), J;
          } finally {
            y.isBatchingLegacy = c;
          }
          if (h !== null && typeof h == "object" && typeof h.then == "function") {
            var k = h, R = !1, L = {
              then: function(J, Q) {
                R = !0, k.then(function(re) {
                  Ye(a), Ce === 0 ? ot(re, J, Q) : J(re);
                }, function(re) {
                  Ye(a), Q(re);
                });
              }
            };
            return !ar && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              R || (ar = !0, x("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), L;
          } else {
            var V = h;
            if (Ye(a), Ce === 0) {
              var H = y.current;
              H !== null && (ut(H), y.current = null);
              var X = {
                then: function(J, Q) {
                  y.current === null ? (y.current = [], ot(V, J, Q)) : J(V);
                }
              };
              return X;
            } else {
              var K = {
                then: function(J, Q) {
                  J(V);
                }
              };
              return K;
            }
          }
        }
      }
      function Ye(t) {
        t !== Ce - 1 && x("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Ce = t;
      }
      function ot(t, a, c) {
        {
          var h = y.current;
          if (h !== null)
            try {
              ut(h), Wn(function() {
                h.length === 0 ? (y.current = null, a(t)) : ot(t, a, c);
              });
            } catch (m) {
              c(m);
            }
          else
            a(t);
        }
      }
      var st = !1;
      function ut(t) {
        if (!st) {
          st = !0;
          var a = 0;
          try {
            for (; a < t.length; a++) {
              var c = t[a];
              do
                c = c(!0);
              while (c !== null);
            }
            t.length = 0;
          } catch (h) {
            throw t = t.slice(a + 1), h;
          } finally {
            st = !1;
          }
        }
      }
      var Vn = rr, Fn = zn, Yn = jn, qn = {
        map: je,
        forEach: tn,
        count: en,
        toArray: rn,
        only: nn
      };
      r.Children = qn, r.Component = _, r.Fragment = u, r.Profiler = f, r.PureComponent = D, r.StrictMode = l, r.Suspense = T, r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ie, r.act = or, r.cloneElement = Fn, r.createContext = an, r.createElement = Vn, r.createFactory = Yn, r.createRef = ne, r.forwardRef = cn, r.isValidElement = Ee, r.lazy = un, r.memo = ln, r.startTransition = $n, r.unstable_act = or, r.useCallback = gn, r.useContext = fn, r.useDebugValue = wn, r.useDeferredValue = Sn, r.useEffect = vn, r.useId = Cn, r.useImperativeHandle = _n, r.useInsertionEffect = yn, r.useLayoutEffect = mn, r.useMemo = bn, r.useReducer = dn, r.useRef = pn, r.useState = hn, r.useSyncExternalStore = Rn, r.useTransition = En, r.version = e, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(De, De.exports)), De.exports;
}
process.env.NODE_ENV === "production" ? mt.exports = Xn() : mt.exports = Kn();
var Ar = mt.exports;
const hr = /* @__PURE__ */ kr(Ar);
var gt = { exports: {} }, Ne = { exports: {} }, q = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dr;
function Jn() {
  if (dr) return q;
  dr = 1;
  var i = typeof Symbol == "function" && Symbol.for, r = i ? Symbol.for("react.element") : 60103, e = i ? Symbol.for("react.portal") : 60106, n = i ? Symbol.for("react.fragment") : 60107, o = i ? Symbol.for("react.strict_mode") : 60108, u = i ? Symbol.for("react.profiler") : 60114, l = i ? Symbol.for("react.provider") : 60109, f = i ? Symbol.for("react.context") : 60110, v = i ? Symbol.for("react.async_mode") : 60111, w = i ? Symbol.for("react.concurrent_mode") : 60111, b = i ? Symbol.for("react.forward_ref") : 60112, T = i ? Symbol.for("react.suspense") : 60113, I = i ? Symbol.for("react.suspense_list") : 60120, j = i ? Symbol.for("react.memo") : 60115, F = i ? Symbol.for("react.lazy") : 60116, z = i ? Symbol.for("react.block") : 60121, W = i ? Symbol.for("react.fundamental") : 60117, B = i ? Symbol.for("react.responder") : 60118, se = i ? Symbol.for("react.scope") : 60119;
  function G(y) {
    if (typeof y == "object" && y !== null) {
      var Z = y.$$typeof;
      switch (Z) {
        case r:
          switch (y = y.type, y) {
            case v:
            case w:
            case n:
            case u:
            case o:
            case T:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case f:
                case b:
                case F:
                case j:
                case l:
                  return y;
                default:
                  return Z;
              }
          }
        case e:
          return Z;
      }
    }
  }
  function Y(y) {
    return G(y) === w;
  }
  return q.AsyncMode = v, q.ConcurrentMode = w, q.ContextConsumer = f, q.ContextProvider = l, q.Element = r, q.ForwardRef = b, q.Fragment = n, q.Lazy = F, q.Memo = j, q.Portal = e, q.Profiler = u, q.StrictMode = o, q.Suspense = T, q.isAsyncMode = function(y) {
    return Y(y) || G(y) === v;
  }, q.isConcurrentMode = Y, q.isContextConsumer = function(y) {
    return G(y) === f;
  }, q.isContextProvider = function(y) {
    return G(y) === l;
  }, q.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === r;
  }, q.isForwardRef = function(y) {
    return G(y) === b;
  }, q.isFragment = function(y) {
    return G(y) === n;
  }, q.isLazy = function(y) {
    return G(y) === F;
  }, q.isMemo = function(y) {
    return G(y) === j;
  }, q.isPortal = function(y) {
    return G(y) === e;
  }, q.isProfiler = function(y) {
    return G(y) === u;
  }, q.isStrictMode = function(y) {
    return G(y) === o;
  }, q.isSuspense = function(y) {
    return G(y) === T;
  }, q.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === w || y === u || y === o || y === T || y === I || typeof y == "object" && y !== null && (y.$$typeof === F || y.$$typeof === j || y.$$typeof === l || y.$$typeof === f || y.$$typeof === b || y.$$typeof === W || y.$$typeof === B || y.$$typeof === se || y.$$typeof === z);
  }, q.typeOf = G, q;
}
var N = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pr;
function Zn() {
  return pr || (pr = 1, process.env.NODE_ENV !== "production" && function() {
    var i = typeof Symbol == "function" && Symbol.for, r = i ? Symbol.for("react.element") : 60103, e = i ? Symbol.for("react.portal") : 60106, n = i ? Symbol.for("react.fragment") : 60107, o = i ? Symbol.for("react.strict_mode") : 60108, u = i ? Symbol.for("react.profiler") : 60114, l = i ? Symbol.for("react.provider") : 60109, f = i ? Symbol.for("react.context") : 60110, v = i ? Symbol.for("react.async_mode") : 60111, w = i ? Symbol.for("react.concurrent_mode") : 60111, b = i ? Symbol.for("react.forward_ref") : 60112, T = i ? Symbol.for("react.suspense") : 60113, I = i ? Symbol.for("react.suspense_list") : 60120, j = i ? Symbol.for("react.memo") : 60115, F = i ? Symbol.for("react.lazy") : 60116, z = i ? Symbol.for("react.block") : 60121, W = i ? Symbol.for("react.fundamental") : 60117, B = i ? Symbol.for("react.responder") : 60118, se = i ? Symbol.for("react.scope") : 60119;
    function G(S) {
      return typeof S == "string" || typeof S == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      S === n || S === w || S === u || S === o || S === T || S === I || typeof S == "object" && S !== null && (S.$$typeof === F || S.$$typeof === j || S.$$typeof === l || S.$$typeof === f || S.$$typeof === b || S.$$typeof === W || S.$$typeof === B || S.$$typeof === se || S.$$typeof === z);
    }
    function Y(S) {
      if (typeof S == "object" && S !== null) {
        var ae = S.$$typeof;
        switch (ae) {
          case r:
            var we = S.type;
            switch (we) {
              case v:
              case w:
              case n:
              case u:
              case o:
              case T:
                return we;
              default:
                var Ae = we && we.$$typeof;
                switch (Ae) {
                  case f:
                  case b:
                  case F:
                  case j:
                  case l:
                    return Ae;
                  default:
                    return ae;
                }
            }
          case e:
            return ae;
        }
      }
    }
    var y = v, Z = w, ce = f, fe = l, pe = r, he = b, ve = n, ye = F, de = j, ue = e, ie = u, ee = o, x = T, le = !1;
    function me(S) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), p(S) || Y(S) === v;
    }
    function p(S) {
      return Y(S) === w;
    }
    function s(S) {
      return Y(S) === f;
    }
    function d(S) {
      return Y(S) === l;
    }
    function E(S) {
      return typeof S == "object" && S !== null && S.$$typeof === r;
    }
    function _(S) {
      return Y(S) === b;
    }
    function C(S) {
      return Y(S) === n;
    }
    function O(S) {
      return Y(S) === F;
    }
    function P(S) {
      return Y(S) === j;
    }
    function M(S) {
      return Y(S) === e;
    }
    function D(S) {
      return Y(S) === u;
    }
    function A(S) {
      return Y(S) === o;
    }
    function ne(S) {
      return Y(S) === T;
    }
    N.AsyncMode = y, N.ConcurrentMode = Z, N.ContextConsumer = ce, N.ContextProvider = fe, N.Element = pe, N.ForwardRef = he, N.Fragment = ve, N.Lazy = ye, N.Memo = de, N.Portal = ue, N.Profiler = ie, N.StrictMode = ee, N.Suspense = x, N.isAsyncMode = me, N.isConcurrentMode = p, N.isContextConsumer = s, N.isContextProvider = d, N.isElement = E, N.isForwardRef = _, N.isFragment = C, N.isLazy = O, N.isMemo = P, N.isPortal = M, N.isProfiler = D, N.isStrictMode = A, N.isSuspense = ne, N.isValidElementType = G, N.typeOf = Y;
  }()), N;
}
var vr;
function Lr() {
  return vr || (vr = 1, process.env.NODE_ENV === "production" ? Ne.exports = Jn() : Ne.exports = Zn()), Ne.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var lt, yr;
function Qn() {
  if (yr) return lt;
  yr = 1;
  var i = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, e = Object.prototype.propertyIsEnumerable;
  function n(u) {
    if (u == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(u);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var u = new String("abc");
      if (u[5] = "de", Object.getOwnPropertyNames(u)[0] === "5")
        return !1;
      for (var l = {}, f = 0; f < 10; f++)
        l["_" + String.fromCharCode(f)] = f;
      var v = Object.getOwnPropertyNames(l).map(function(b) {
        return l[b];
      });
      if (v.join("") !== "0123456789")
        return !1;
      var w = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(b) {
        w[b] = b;
      }), Object.keys(Object.assign({}, w)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return lt = o() ? Object.assign : function(u, l) {
    for (var f, v = n(u), w, b = 1; b < arguments.length; b++) {
      f = Object(arguments[b]);
      for (var T in f)
        r.call(f, T) && (v[T] = f[T]);
      if (i) {
        w = i(f);
        for (var I = 0; I < w.length; I++)
          e.call(f, w[I]) && (v[w[I]] = f[w[I]]);
      }
    }
    return v;
  }, lt;
}
var ft, mr;
function St() {
  if (mr) return ft;
  mr = 1;
  var i = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ft = i, ft;
}
var ht, gr;
function Ir() {
  return gr || (gr = 1, ht = Function.call.bind(Object.prototype.hasOwnProperty)), ht;
}
var dt, br;
function ei() {
  if (br) return dt;
  br = 1;
  var i = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = St(), e = {}, n = Ir();
    i = function(u) {
      var l = "Warning: " + u;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function o(u, l, f, v, w) {
    if (process.env.NODE_ENV !== "production") {
      for (var b in u)
        if (n(u, b)) {
          var T;
          try {
            if (typeof u[b] != "function") {
              var I = Error(
                (v || "React class") + ": " + f + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw I.name = "Invariant Violation", I;
            }
            T = u[b](l, b, v, f, null, r);
          } catch (F) {
            T = F;
          }
          if (T && !(T instanceof Error) && i(
            (v || "React class") + ": type specification of " + f + " `" + b + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof T + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), T instanceof Error && !(T.message in e)) {
            e[T.message] = !0;
            var j = w ? w() : "";
            i(
              "Failed " + f + " type: " + T.message + (j ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (e = {});
  }, dt = o, dt;
}
var pt, _r;
function ti() {
  if (_r) return pt;
  _r = 1;
  var i = Lr(), r = Qn(), e = St(), n = Ir(), o = ei(), u = function() {
  };
  process.env.NODE_ENV !== "production" && (u = function(f) {
    var v = "Warning: " + f;
    typeof console < "u" && console.error(v);
    try {
      throw new Error(v);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return pt = function(f, v) {
    var w = typeof Symbol == "function" && Symbol.iterator, b = "@@iterator";
    function T(p) {
      var s = p && (w && p[w] || p[b]);
      if (typeof s == "function")
        return s;
    }
    var I = "<<anonymous>>", j = {
      array: B("array"),
      bigint: B("bigint"),
      bool: B("boolean"),
      func: B("function"),
      number: B("number"),
      object: B("object"),
      string: B("string"),
      symbol: B("symbol"),
      any: se(),
      arrayOf: G,
      element: Y(),
      elementType: y(),
      instanceOf: Z,
      node: he(),
      objectOf: fe,
      oneOf: ce,
      oneOfType: pe,
      shape: ye,
      exact: de
    };
    function F(p, s) {
      return p === s ? p !== 0 || 1 / p === 1 / s : p !== p && s !== s;
    }
    function z(p, s) {
      this.message = p, this.data = s && typeof s == "object" ? s : {}, this.stack = "";
    }
    z.prototype = Error.prototype;
    function W(p) {
      if (process.env.NODE_ENV !== "production")
        var s = {}, d = 0;
      function E(C, O, P, M, D, A, ne) {
        if (M = M || I, A = A || P, ne !== e) {
          if (v) {
            var S = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw S.name = "Invariant Violation", S;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ae = M + ":" + P;
            !s[ae] && // Avoid spamming the console because they are often not actionable except for lib authors
            d < 3 && (u(
              "You are manually calling a React.PropTypes validation function for the `" + A + "` prop on `" + M + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), s[ae] = !0, d++);
          }
        }
        return O[P] == null ? C ? O[P] === null ? new z("The " + D + " `" + A + "` is marked as required " + ("in `" + M + "`, but its value is `null`.")) : new z("The " + D + " `" + A + "` is marked as required in " + ("`" + M + "`, but its value is `undefined`.")) : null : p(O, P, M, D, A);
      }
      var _ = E.bind(null, !1);
      return _.isRequired = E.bind(null, !0), _;
    }
    function B(p) {
      function s(d, E, _, C, O, P) {
        var M = d[E], D = ee(M);
        if (D !== p) {
          var A = x(M);
          return new z(
            "Invalid " + C + " `" + O + "` of type " + ("`" + A + "` supplied to `" + _ + "`, expected ") + ("`" + p + "`."),
            { expectedType: p }
          );
        }
        return null;
      }
      return W(s);
    }
    function se() {
      return W(l);
    }
    function G(p) {
      function s(d, E, _, C, O) {
        if (typeof p != "function")
          return new z("Property `" + O + "` of component `" + _ + "` has invalid PropType notation inside arrayOf.");
        var P = d[E];
        if (!Array.isArray(P)) {
          var M = ee(P);
          return new z("Invalid " + C + " `" + O + "` of type " + ("`" + M + "` supplied to `" + _ + "`, expected an array."));
        }
        for (var D = 0; D < P.length; D++) {
          var A = p(P, D, _, C, O + "[" + D + "]", e);
          if (A instanceof Error)
            return A;
        }
        return null;
      }
      return W(s);
    }
    function Y() {
      function p(s, d, E, _, C) {
        var O = s[d];
        if (!f(O)) {
          var P = ee(O);
          return new z("Invalid " + _ + " `" + C + "` of type " + ("`" + P + "` supplied to `" + E + "`, expected a single ReactElement."));
        }
        return null;
      }
      return W(p);
    }
    function y() {
      function p(s, d, E, _, C) {
        var O = s[d];
        if (!i.isValidElementType(O)) {
          var P = ee(O);
          return new z("Invalid " + _ + " `" + C + "` of type " + ("`" + P + "` supplied to `" + E + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return W(p);
    }
    function Z(p) {
      function s(d, E, _, C, O) {
        if (!(d[E] instanceof p)) {
          var P = p.name || I, M = me(d[E]);
          return new z("Invalid " + C + " `" + O + "` of type " + ("`" + M + "` supplied to `" + _ + "`, expected ") + ("instance of `" + P + "`."));
        }
        return null;
      }
      return W(s);
    }
    function ce(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? u(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : u("Invalid argument supplied to oneOf, expected an array.")), l;
      function s(d, E, _, C, O) {
        for (var P = d[E], M = 0; M < p.length; M++)
          if (F(P, p[M]))
            return null;
        var D = JSON.stringify(p, function(ne, S) {
          var ae = x(S);
          return ae === "symbol" ? String(S) : S;
        });
        return new z("Invalid " + C + " `" + O + "` of value `" + String(P) + "` " + ("supplied to `" + _ + "`, expected one of " + D + "."));
      }
      return W(s);
    }
    function fe(p) {
      function s(d, E, _, C, O) {
        if (typeof p != "function")
          return new z("Property `" + O + "` of component `" + _ + "` has invalid PropType notation inside objectOf.");
        var P = d[E], M = ee(P);
        if (M !== "object")
          return new z("Invalid " + C + " `" + O + "` of type " + ("`" + M + "` supplied to `" + _ + "`, expected an object."));
        for (var D in P)
          if (n(P, D)) {
            var A = p(P, D, _, C, O + "." + D, e);
            if (A instanceof Error)
              return A;
          }
        return null;
      }
      return W(s);
    }
    function pe(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && u("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var s = 0; s < p.length; s++) {
        var d = p[s];
        if (typeof d != "function")
          return u(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + le(d) + " at index " + s + "."
          ), l;
      }
      function E(_, C, O, P, M) {
        for (var D = [], A = 0; A < p.length; A++) {
          var ne = p[A], S = ne(_, C, O, P, M, e);
          if (S == null)
            return null;
          S.data && n(S.data, "expectedType") && D.push(S.data.expectedType);
        }
        var ae = D.length > 0 ? ", expected one of type [" + D.join(", ") + "]" : "";
        return new z("Invalid " + P + " `" + M + "` supplied to " + ("`" + O + "`" + ae + "."));
      }
      return W(E);
    }
    function he() {
      function p(s, d, E, _, C) {
        return ue(s[d]) ? null : new z("Invalid " + _ + " `" + C + "` supplied to " + ("`" + E + "`, expected a ReactNode."));
      }
      return W(p);
    }
    function ve(p, s, d, E, _) {
      return new z(
        (p || "React class") + ": " + s + " type `" + d + "." + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _ + "`."
      );
    }
    function ye(p) {
      function s(d, E, _, C, O) {
        var P = d[E], M = ee(P);
        if (M !== "object")
          return new z("Invalid " + C + " `" + O + "` of type `" + M + "` " + ("supplied to `" + _ + "`, expected `object`."));
        for (var D in p) {
          var A = p[D];
          if (typeof A != "function")
            return ve(_, C, O, D, x(A));
          var ne = A(P, D, _, C, O + "." + D, e);
          if (ne)
            return ne;
        }
        return null;
      }
      return W(s);
    }
    function de(p) {
      function s(d, E, _, C, O) {
        var P = d[E], M = ee(P);
        if (M !== "object")
          return new z("Invalid " + C + " `" + O + "` of type `" + M + "` " + ("supplied to `" + _ + "`, expected `object`."));
        var D = r({}, d[E], p);
        for (var A in D) {
          var ne = p[A];
          if (n(p, A) && typeof ne != "function")
            return ve(_, C, O, A, x(ne));
          if (!ne)
            return new z(
              "Invalid " + C + " `" + O + "` key `" + A + "` supplied to `" + _ + "`.\nBad object: " + JSON.stringify(d[E], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(p), null, "  ")
            );
          var S = ne(P, A, _, C, O + "." + A, e);
          if (S)
            return S;
        }
        return null;
      }
      return W(s);
    }
    function ue(p) {
      switch (typeof p) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !p;
        case "object":
          if (Array.isArray(p))
            return p.every(ue);
          if (p === null || f(p))
            return !0;
          var s = T(p);
          if (s) {
            var d = s.call(p), E;
            if (s !== p.entries) {
              for (; !(E = d.next()).done; )
                if (!ue(E.value))
                  return !1;
            } else
              for (; !(E = d.next()).done; ) {
                var _ = E.value;
                if (_ && !ue(_[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ie(p, s) {
      return p === "symbol" ? !0 : s ? s["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && s instanceof Symbol : !1;
    }
    function ee(p) {
      var s = typeof p;
      return Array.isArray(p) ? "array" : p instanceof RegExp ? "object" : ie(s, p) ? "symbol" : s;
    }
    function x(p) {
      if (typeof p > "u" || p === null)
        return "" + p;
      var s = ee(p);
      if (s === "object") {
        if (p instanceof Date)
          return "date";
        if (p instanceof RegExp)
          return "regexp";
      }
      return s;
    }
    function le(p) {
      var s = x(p);
      switch (s) {
        case "array":
        case "object":
          return "an " + s;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + s;
        default:
          return s;
      }
    }
    function me(p) {
      return !p.constructor || !p.constructor.name ? I : p.constructor.name;
    }
    return j.checkPropTypes = o, j.resetWarningCache = o.resetWarningCache, j.PropTypes = j, j;
  }, pt;
}
var vt, wr;
function ri() {
  if (wr) return vt;
  wr = 1;
  var i = St();
  function r() {
  }
  function e() {
  }
  return e.resetWarningCache = r, vt = function() {
    function n(l, f, v, w, b, T) {
      if (T !== i) {
        var I = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw I.name = "Invariant Violation", I;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var u = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: e,
      resetWarningCache: r
    };
    return u.PropTypes = u, u;
  }, vt;
}
if (process.env.NODE_ENV !== "production") {
  var ni = Lr(), ii = !0;
  gt.exports = ti()(ni.isElement, ii);
} else
  gt.exports = ri()();
var ai = gt.exports;
const U = /* @__PURE__ */ kr(ai);
var be = {}, Ct = {}, Ge = {}, Xe = {};
Object.defineProperty(Xe, "__esModule", {
  value: !0
});
function oi(i, r) {
  if (!(i instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
var si = (
  /**
   *
   * @param {number} x
   * @param {number} y
   */
  function i(r, e) {
    oi(this, i), this.x = r, this.y = e;
  }
);
Xe.default = si;
Object.defineProperty(Ge, "__esModule", {
  value: !0
});
var ui = /* @__PURE__ */ function() {
  function i(r, e) {
    for (var n = 0; n < e.length; n++) {
      var o = e[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(r, o.key, o);
    }
  }
  return function(r, e, n) {
    return e && i(r.prototype, e), n && i(r, n), r;
  };
}(), ci = Xe, Er = li(ci);
function li(i) {
  return i && i.__esModule ? i : { default: i };
}
function fi(i, r) {
  if (!(i instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function hi(i, r) {
  if (!i)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r && (typeof r == "object" || typeof r == "function") ? r : i;
}
function di(i, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof r);
  i.prototype = Object.create(r && r.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(i, r) : i.__proto__ = r);
}
var pi = function(i) {
  di(r, i);
  function r() {
    return fi(this, r), hi(this, (r.__proto__ || Object.getPrototypeOf(r)).apply(this, arguments));
  }
  return ui(r, [{
    key: "update",
    /**
     * Update the x and y values
     *
     * @param {Point} point
     */
    value: function(n) {
      this.x = n.x, this.y = n.y;
    }
    /**
     * Move the point to another position using an angle and distance
     *
     * @param {number} angle The angle in radians
     * @param {number} distance How much the point should be moved
     */
  }, {
    key: "moveByAngle",
    value: function(n, o) {
      var u = n + Math.PI / 2;
      this.x = this.x + Math.sin(u) * o, this.y = this.y - Math.cos(u) * o;
    }
    /**
     * Check if this point is the same as another point
     *
     * @param {Point} point
     * @returns {boolean}
     */
  }, {
    key: "equalsTo",
    value: function(n) {
      return this.x === n.x && this.y === n.y;
    }
    /**
     * Get the difference for x and y axis to another point
     *
     * @param {Point} point
     * @returns {Point}
     */
  }, {
    key: "getDifferenceTo",
    value: function(n) {
      return new Er.default(this.x - n.x, this.y - n.y);
    }
    /**
     * Calculate distance to another point
     *
     * @param {Point} point
     * @returns {Point}
     */
  }, {
    key: "getDistanceTo",
    value: function(n) {
      var o = this.getDifferenceTo(n);
      return Math.sqrt(Math.pow(o.x, 2) + Math.pow(o.y, 2));
    }
    /**
     * Calculate the angle to another point
     *
     * @param {Point} point
     * @returns {Point}
     */
  }, {
    key: "getAngleTo",
    value: function(n) {
      var o = this.getDifferenceTo(n);
      return Math.atan2(o.y, o.x);
    }
    /**
     * Return a simple object with x and y properties
     *
     * @returns {object}
     */
  }, {
    key: "toObject",
    value: function() {
      return {
        x: this.x,
        y: this.y
      };
    }
  }]), r;
}(Er.default);
Ge.default = pi;
Object.defineProperty(Ct, "__esModule", {
  value: !0
});
var vi = /* @__PURE__ */ function() {
  function i(r, e) {
    for (var n = 0; n < e.length; n++) {
      var o = e[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(r, o.key, o);
    }
  }
  return function(r, e, n) {
    return e && i(r.prototype, e), n && i(r, n), r;
  };
}(), yi = Ge, Sr = mi(yi);
function mi(i) {
  return i && i.__esModule ? i : { default: i };
}
function gi(i, r) {
  if (!(i instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
var bi = 30, _i = function() {
  function i() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = r.radius, n = e === void 0 ? bi : e, o = r.enabled, u = o === void 0 ? !0 : o, l = r.initialPoint, f = l === void 0 ? { x: 0, y: 0 } : l;
    gi(this, i), this.radius = n, this._isEnabled = u, this.pointer = new Sr.default(f.x, f.y), this.brush = new Sr.default(f.x, f.y), this.angle = 0, this.distance = 0, this._hasMoved = !1;
  }
  return vi(i, [{
    key: "enable",
    value: function() {
      this._isEnabled = !0;
    }
    /**
     * Disable lazy brush calculations.
     *
     */
  }, {
    key: "disable",
    value: function() {
      this._isEnabled = !1;
    }
    /**
     * @returns {boolean}
     */
  }, {
    key: "isEnabled",
    value: function() {
      return this._isEnabled;
    }
    /**
     * Update the radius
     *
     * @param {number} radius
     */
  }, {
    key: "setRadius",
    value: function(e) {
      this.radius = e;
    }
    /**
     * Return the current radius
     *
     * @returns {number}
     */
  }, {
    key: "getRadius",
    value: function() {
      return this.radius;
    }
    /**
     * Return the brush coordinates as a simple object
     *
     * @returns {object}
     */
  }, {
    key: "getBrushCoordinates",
    value: function() {
      return this.brush.toObject();
    }
    /**
     * Return the pointer coordinates as a simple object
     *
     * @returns {object}
     */
  }, {
    key: "getPointerCoordinates",
    value: function() {
      return this.pointer.toObject();
    }
    /**
     * Return the brush as a LazyPoint
     *
     * @returns {LazyPoint}
     */
  }, {
    key: "getBrush",
    value: function() {
      return this.brush;
    }
    /**
     * Return the pointer as a LazyPoint
     *
     * @returns {LazyPoint}
     */
  }, {
    key: "getPointer",
    value: function() {
      return this.pointer;
    }
    /**
     * Return the angle between pointer and brush
     *
     * @returns {number} Angle in radians
     */
  }, {
    key: "getAngle",
    value: function() {
      return this.angle;
    }
    /**
     * Return the distance between pointer and brush
     *
     * @returns {number} Distance in pixels
     */
  }, {
    key: "getDistance",
    value: function() {
      return this.distance;
    }
    /**
     * Return if the previous update has moved the brush.
     *
     * @returns {boolean} Whether the brush moved previously.
     */
  }, {
    key: "brushHasMoved",
    value: function() {
      return this._hasMoved;
    }
    /**
     * Updates the pointer point and calculates the new brush point.
     *
     * @param {Point} newPointerPoint
     * @param {Object} options
     * @param {Boolean} options.both Force update pointer and brush
     * @returns {Boolean} Whether any of the two points changed
     */
  }, {
    key: "update",
    value: function(e) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.both, u = o === void 0 ? !1 : o;
      return this._hasMoved = !1, this.pointer.equalsTo(e) && !u ? !1 : (this.pointer.update(e), u ? (this._hasMoved = !0, this.brush.update(e), !0) : (this._isEnabled ? (this.distance = this.pointer.getDistanceTo(this.brush), this.angle = this.pointer.getAngleTo(this.brush), this.distance > this.radius && (this.brush.moveByAngle(this.angle, this.distance - this.radius), this._hasMoved = !0)) : (this.distance = 0, this.angle = 0, this.brush.update(e), this._hasMoved = !0), !0));
    }
  }]), i;
}();
Ct.default = _i;
Object.defineProperty(be, "__esModule", {
  value: !0
});
be.LazyPoint = be.Point = jr = be.LazyBrush = void 0;
var wi = Ct, Ei = Rt(wi), Si = Xe, Ci = Rt(Si), Ri = Ge, Ti = Rt(Ri);
function Rt(i) {
  return i && i.__esModule ? i : { default: i };
}
var jr = be.LazyBrush = Ei.default;
be.Point = Ci.default;
be.LazyPoint = Ti.default;
var ke = {}, Tt = {}, Ke = {};
Object.defineProperty(Ke, "__esModule", {
  value: !0
});
var Oi = /* @__PURE__ */ function() {
  function i(r, e) {
    for (var n = 0; n < e.length; n++) {
      var o = e[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(r, o.key, o);
    }
  }
  return function(r, e, n) {
    return e && i(r.prototype, e), n && i(r, n), r;
  };
}();
function Pi(i, r) {
  if (!(i instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
var xi = function() {
  function i(r, e) {
    Pi(this, i), this.x = r, this.y = e;
  }
  return Oi(i, [{
    key: "update",
    value: function(e) {
      this.x = e.x, this.y = e.y;
    }
    /**
     * Get the difference for x and y axis to another point
     *
     * @param {Point} point
     * @returns {Point}
     */
  }, {
    key: "getDifferenceTo",
    value: function(e) {
      return new i(this.x - e.x, this.y - e.y);
    }
    /**
     * Calculate distance to another point
     *
     * @param {Point} point
     * @returns {Point}
     */
  }, {
    key: "getDistanceTo",
    value: function(e) {
      var n = this.getDifferenceTo(e);
      return Math.sqrt(Math.pow(n.x, 2) + Math.pow(n.y, 2));
    }
  }]), i;
}();
Ke.default = xi;
Object.defineProperty(Tt, "__esModule", {
  value: !0
});
var Mi = /* @__PURE__ */ function() {
  function i(r, e) {
    for (var n = 0; n < e.length; n++) {
      var o = e[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(r, o.key, o);
    }
  }
  return function(r, e, n) {
    return e && i(r.prototype, e), n && i(r, n), r;
  };
}(), Di = Ke, Cr = ki(Di);
function ki(i) {
  return i && i.__esModule ? i : { default: i };
}
function Ai(i, r) {
  if (!(i instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
var Li = 1e-6, Ii = function() {
  function i() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = r.segments, n = e === void 0 ? 50 : e, o = r.iterationLimit, u = o === void 0 ? 100 : o;
    Ai(this, i), this.p1 = new Cr.default(), this.p2 = new Cr.default(), this.segments = n, this.iterationLimit = u;
  }
  return Mi(i, [{
    key: "drawToCanvas",
    value: function(e, n, o, u) {
      this.p1.update(n), this.p2.update(o);
      var l = this.p1.x > this.p2.x, f = l ? this.p2 : this.p1, v = l ? this.p1 : this.p2, w = f.getDistanceTo(v), b = [], T = !0;
      if (w < u) {
        var I = v.x - f.x;
        if (I > 0.01) {
          var j = v.x - f.x, F = v.y - f.y, z = -this.getCatenaryParameter(j, F, u, this.iterationLimit), W = (z * Math.log((u + F) / (u - F)) - j) * 0.5, B = z * Math.cosh(W / z), se = f.x - W, G = f.y - B;
          b = this.getCurve(z, f, v, se, G, this.segments), T = !1;
        } else {
          var Y = (f.x + v.x) * 0.5, y = (f.y + v.y + u) * 0.5;
          b = [[f.x, f.y], [Y, y], [v.x, v.y]];
        }
      } else
        b = [[f.x, f.y], [v.x, v.y]];
      return T ? this.drawLine(b, e) : this.drawCurve(b, e), b;
    }
    /**
     * Determines catenary parameter.
     * 
     * @param {Number} h Horizontal distance of both points.
     * @param {Number} v Vertical distance of both points.
     * @param {Number} length The catenary length.
     * @param {Number} limit Maximum amount of iterations to find parameter.
     */
  }, {
    key: "getCatenaryParameter",
    value: function(e, n, o, u) {
      for (var l = Math.sqrt(o * o - n * n) / e, f = Math.acosh(l) + 1, v = -1, w = 0; Math.abs(f - v) > Li && w < u; )
        v = f, f = f - (Math.sinh(f) - l * f) / (Math.cosh(f) - l), w++;
      return e / (2 * f);
    }
    /**
     * Calculate the catenary curve.
     * Increasing the segments value will produce a catenary closer
     * to reality, but will require more calcluations.
     * 
     * @param {Number} a The catenary parameter.
     * @param {Point} p1 First point
     * @param {Point} p2 Second point
     * @param {Number} offsetX The calculated offset on the x axis.
     * @param {Number} offsetY The calculated offset on the y axis.
     * @param {Number} segments How many "parts" the chain should be made of.
     */
  }, {
    key: "getCurve",
    value: function(e, n, o, u, l, f) {
      for (var v = [n.x, e * Math.cosh((n.x - u) / e) + l], w = o.x - n.x, b = f - 1, T = 0; T < b; T++) {
        var I = n.x + w * (T + 0.5) / b, j = e * Math.cosh((I - u) / e) + l;
        v.push(I, j);
      }
      return v.push(o.x, e * Math.cosh((o.x - u) / e) + l), v;
    }
    /**
     * Draws a straight line between two points.
     *
     * @param {Array} data Even indices are x, odd are y.
     * @param {CanvasRenderingContext2D} context The context to draw to.
     */
  }, {
    key: "drawLine",
    value: function(e, n) {
      n.moveTo(e[0][0], e[0][1]), n.lineTo(e[1][0], e[1][1]);
    }
    /**
     * Draws a quadratic curve between every calculated catenary segment,
     * so that the segments don't look like straight lines.
     *
     * @param {Array} data Even indices are x, odd are y.
     * @param {CanvasRenderingContext2D} context The context to draw to.
     * 
     * @returns {Array} The original segment coordinates.
     */
  }, {
    key: "drawCurve",
    value: function(e, n) {
      var o = e.length * 0.5 - 1, u = e[2], l = e[3], f = [];
      n.moveTo(e[0], e[1]);
      for (var v = 2; v < o; v++) {
        var w = e[v * 2], b = e[v * 2 + 1], T = (w + u) * 0.5, I = (b + l) * 0.5;
        f.push([u, l, T, I]), n.quadraticCurveTo(u, l, T, I), u = w, l = b;
      }
      return o = e.length, n.quadraticCurveTo(e[o - 4], e[o - 3], e[o - 2], e[o - 1]), f;
    }
  }]), i;
}();
Tt.default = Ii;
Object.defineProperty(ke, "__esModule", {
  value: !0
});
ke.Point = $r = ke.Catenary = void 0;
var ji = Tt, zi = zr(ji), $i = Ke, Wi = zr($i);
function zr(i) {
  return i && i.__esModule ? i : { default: i };
}
var $r = ke.Catenary = zi.default;
ke.Point = Wi.default;
var Wr = function() {
  if (typeof Map < "u")
    return Map;
  function i(r, e) {
    var n = -1;
    return r.some(function(o, u) {
      return o[0] === e ? (n = u, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function r() {
        this.__entries__ = [];
      }
      return Object.defineProperty(r.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), r.prototype.get = function(e) {
        var n = i(this.__entries__, e), o = this.__entries__[n];
        return o && o[1];
      }, r.prototype.set = function(e, n) {
        var o = i(this.__entries__, e);
        ~o ? this.__entries__[o][1] = n : this.__entries__.push([e, n]);
      }, r.prototype.delete = function(e) {
        var n = this.__entries__, o = i(n, e);
        ~o && n.splice(o, 1);
      }, r.prototype.has = function(e) {
        return !!~i(this.__entries__, e);
      }, r.prototype.clear = function() {
        this.__entries__.splice(0);
      }, r.prototype.forEach = function(e, n) {
        n === void 0 && (n = null);
        for (var o = 0, u = this.__entries__; o < u.length; o++) {
          var l = u[o];
          e.call(n, l[1], l[0]);
        }
      }, r;
    }()
  );
}(), bt = typeof window < "u" && typeof document < "u" && window.document === document, Be = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Vi = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Be) : function(i) {
    return setTimeout(function() {
      return i(Date.now());
    }, 1e3 / 60);
  };
}(), Fi = 2;
function Yi(i, r) {
  var e = !1, n = !1, o = 0;
  function u() {
    e && (e = !1, i()), n && f();
  }
  function l() {
    Vi(u);
  }
  function f() {
    var v = Date.now();
    if (e) {
      if (v - o < Fi)
        return;
      n = !0;
    } else
      e = !0, n = !1, setTimeout(l, r);
    o = v;
  }
  return f;
}
var qi = 20, Ni = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Ui = typeof MutationObserver < "u", Bi = (
  /** @class */
  function() {
    function i() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Yi(this.refresh.bind(this), qi);
    }
    return i.prototype.addObserver = function(r) {
      ~this.observers_.indexOf(r) || this.observers_.push(r), this.connected_ || this.connect_();
    }, i.prototype.removeObserver = function(r) {
      var e = this.observers_, n = e.indexOf(r);
      ~n && e.splice(n, 1), !e.length && this.connected_ && this.disconnect_();
    }, i.prototype.refresh = function() {
      var r = this.updateObservers_();
      r && this.refresh();
    }, i.prototype.updateObservers_ = function() {
      var r = this.observers_.filter(function(e) {
        return e.gatherActive(), e.hasActive();
      });
      return r.forEach(function(e) {
        return e.broadcastActive();
      }), r.length > 0;
    }, i.prototype.connect_ = function() {
      !bt || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Ui ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, i.prototype.disconnect_ = function() {
      !bt || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, i.prototype.onTransitionEnd_ = function(r) {
      var e = r.propertyName, n = e === void 0 ? "" : e, o = Ni.some(function(u) {
        return !!~n.indexOf(u);
      });
      o && this.refresh();
    }, i.getInstance = function() {
      return this.instance_ || (this.instance_ = new i()), this.instance_;
    }, i.instance_ = null, i;
  }()
), Vr = function(i, r) {
  for (var e = 0, n = Object.keys(r); e < n.length; e++) {
    var o = n[e];
    Object.defineProperty(i, o, {
      value: r[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return i;
}, Te = function(i) {
  var r = i && i.ownerDocument && i.ownerDocument.defaultView;
  return r || Be;
}, Fr = Je(0, 0, 0, 0);
function He(i) {
  return parseFloat(i) || 0;
}
function Rr(i) {
  for (var r = [], e = 1; e < arguments.length; e++)
    r[e - 1] = arguments[e];
  return r.reduce(function(n, o) {
    var u = i["border-" + o + "-width"];
    return n + He(u);
  }, 0);
}
function Hi(i) {
  for (var r = ["top", "right", "bottom", "left"], e = {}, n = 0, o = r; n < o.length; n++) {
    var u = o[n], l = i["padding-" + u];
    e[u] = He(l);
  }
  return e;
}
function Gi(i) {
  var r = i.getBBox();
  return Je(0, 0, r.width, r.height);
}
function Xi(i) {
  var r = i.clientWidth, e = i.clientHeight;
  if (!r && !e)
    return Fr;
  var n = Te(i).getComputedStyle(i), o = Hi(n), u = o.left + o.right, l = o.top + o.bottom, f = He(n.width), v = He(n.height);
  if (n.boxSizing === "border-box" && (Math.round(f + u) !== r && (f -= Rr(n, "left", "right") + u), Math.round(v + l) !== e && (v -= Rr(n, "top", "bottom") + l)), !Ji(i)) {
    var w = Math.round(f + u) - r, b = Math.round(v + l) - e;
    Math.abs(w) !== 1 && (f -= w), Math.abs(b) !== 1 && (v -= b);
  }
  return Je(o.left, o.top, f, v);
}
var Ki = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(i) {
    return i instanceof Te(i).SVGGraphicsElement;
  } : function(i) {
    return i instanceof Te(i).SVGElement && typeof i.getBBox == "function";
  };
}();
function Ji(i) {
  return i === Te(i).document.documentElement;
}
function Zi(i) {
  return bt ? Ki(i) ? Gi(i) : Xi(i) : Fr;
}
function Qi(i) {
  var r = i.x, e = i.y, n = i.width, o = i.height, u = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, l = Object.create(u.prototype);
  return Vr(l, {
    x: r,
    y: e,
    width: n,
    height: o,
    top: e,
    right: r + n,
    bottom: o + e,
    left: r
  }), l;
}
function Je(i, r, e, n) {
  return { x: i, y: r, width: e, height: n };
}
var ea = (
  /** @class */
  function() {
    function i(r) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Je(0, 0, 0, 0), this.target = r;
    }
    return i.prototype.isActive = function() {
      var r = Zi(this.target);
      return this.contentRect_ = r, r.width !== this.broadcastWidth || r.height !== this.broadcastHeight;
    }, i.prototype.broadcastRect = function() {
      var r = this.contentRect_;
      return this.broadcastWidth = r.width, this.broadcastHeight = r.height, r;
    }, i;
  }()
), ta = (
  /** @class */
  /* @__PURE__ */ function() {
    function i(r, e) {
      var n = Qi(e);
      Vr(this, { target: r, contentRect: n });
    }
    return i;
  }()
), ra = (
  /** @class */
  function() {
    function i(r, e, n) {
      if (this.activeObservations_ = [], this.observations_ = new Wr(), typeof r != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = r, this.controller_ = e, this.callbackCtx_ = n;
    }
    return i.prototype.observe = function(r) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(r instanceof Te(r).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var e = this.observations_;
        e.has(r) || (e.set(r, new ea(r)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, i.prototype.unobserve = function(r) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(r instanceof Te(r).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var e = this.observations_;
        e.has(r) && (e.delete(r), e.size || this.controller_.removeObserver(this));
      }
    }, i.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, i.prototype.gatherActive = function() {
      var r = this;
      this.clearActive(), this.observations_.forEach(function(e) {
        e.isActive() && r.activeObservations_.push(e);
      });
    }, i.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var r = this.callbackCtx_, e = this.activeObservations_.map(function(n) {
          return new ta(n.target, n.broadcastRect());
        });
        this.callback_.call(r, e, r), this.clearActive();
      }
    }, i.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, i.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, i;
  }()
), Yr = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new Wr(), qr = (
  /** @class */
  /* @__PURE__ */ function() {
    function i(r) {
      if (!(this instanceof i))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var e = Bi.getInstance(), n = new ra(r, e, this);
      Yr.set(this, n);
    }
    return i;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(i) {
  qr.prototype[i] = function() {
    var r;
    return (r = Yr.get(this))[i].apply(r, arguments);
  };
});
var na = function() {
  return typeof Be.ResizeObserver < "u" ? Be.ResizeObserver : qr;
}();
const Tr = Object.freeze({
  x: 0,
  y: 0,
  untransformedX: 0,
  untransformedY: 0
}), yt = Object.freeze({
  canvasWidth: 0,
  canvasHeight: 0,
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  viewMin: Tr,
  viewMax: Tr
}), Re = Object.freeze({ a: 1, b: 0, c: 0, d: 1, e: 0, f: 0 });
class ia {
  /**
   * @typedef Extents
   * @property {number} min the minimal value in the range
   * @property {number} max the maximal value in the range
   */
  /**
   * @typedef Size
   * @property {number} width the span of the element's horizontal axis
   * @property {number} height the span of the element's vertical axis
   */
  /**
   * @param {Object} parameters the initialization parameters for this instance.
   * @param {Extents} parameters.scaleExtents the minimum and maximum allowable scale factor.
   * @param {Sizee} parameters.documentSize the width and height of the document, in client space.
   */
  constructor({ scaleExtents: r, documentSize: e }) {
    /**
     * @type {Extents}
     */
    g(this, "_scaleExtents");
    /**
     * @type {Size}
     */
    g(this, "_documentSize");
    /**
     * @typedef Canvas
     * @property {number} width the canvas's width
     * @property {number} height the canvas's height
     * @property {() => Object} getBoundingClientRect returns the client bounds
     */
    /**
     * @type {Canvas}
     * @private
     */
    g(this, "_canvas", null);
    /**
     * @typedef View
     * @property {number} scale the zoom factor
     * @property {number} x the current x offset
     * @property {number} y the current y offset
     */
    /**
     * @type {View}
     * @private
     */
    g(this, "_view", { scale: 1, x: 0, y: 0 });
    /**
     * Describes a callback function that receives info about view changes
     * @typedef {(update: { view: View, transform: Matrix }) => void} ViewListener
     */
    /**
     * @type {ViewListener[]}
     * @private
     */
    g(this, "_viewChangeListeners", /* @__PURE__ */ new Set());
    /**
     * Sets the zoom factor (clamped by the scale extents) and updates the view.
     * @param {number} the new zoom factor
     */
    g(this, "setScale", (r) => {
      this.setView({ scale: r });
    });
    /**
     * Calculates a variant of the given view clamped according to the scale and
     * document bounds. Does not modify this instance.
     * @param {View} view the view constraints to clamp.
     * @returns {View} a new view object representing the constrained input.
     */
    g(this, "clampView", ({ scale: r, x: e, y: n }) => {
      const { min: o, max: u } = this.scaleExtents, { width: l, height: f } = this.documentSize, { left: v, top: w, right: b, bottom: T } = this.canvasRect || yt, I = b - v, j = T - w, F = I / 2, z = -(l * this._view.scale - I / 2), W = j / 2, B = -(f * this._view.scale - j / 2);
      return {
        scale: Math.min(Math.max(r, o), u),
        x: Math.min(Math.max(e, z), F),
        y: Math.min(Math.max(n, B), W)
      };
    });
    /**
     * Resets the view transform to its default state.
     */
    g(this, "resetView", () => {
      this.setView({ scale: 1, x: 0, y: 0 });
    });
    /**
     * Updates the view, ensuring that it is within the document and scale bounds.
     * @param {View} view
     *    the new view state. Any view property not specified will remain
     *    unchanged.
     * @return {View}
     *    a copy of the view state after having been constrained and applied.
     */
    g(this, "setView", (r) => {
      const e = this.clampView({ ...this._view, ...r || {} }), { scale: n, x: o, y: u } = this._view;
      return (e.scale !== n || e.x !== o || e.y !== u) && (this._view = e, this._viewChangeListeners.forEach((l) => l && l(e))), { ...this._view };
    });
    /**
     * Updates the current view scale while attempting to keep the given point
     * fixed within the canvas.
     *
     * @param {number} deltaScale the amount by which to change the current scale factor.
     * @param {ClientPoint} clientPoint the origin of the zoom, in client space.
     *
     * @returns {View} the newly computed view.
     */
    g(this, "scaleAtClientPoint", (r, e) => {
      const n = this.clientPointToViewPoint(e), o = this.clampView({ ...this._view, scale: this._view.scale + r }), u = this.viewPointToClientPoint(n, o);
      return o.x = this._view.x - (u.clientX - e.clientX), o.y = this._view.y - (u.clientY - e.clientY), this.setView(o);
    });
    /**
     * Describes a point in view space (client space after the viewport transform
     * has been applied).
     * @typedef ViewPoint
     * @property {number} x
     *    the x-coordinate in view space
     * @property {number} y
     *    the y-coordinate in view space
     * @property {number} relativeClientX
     *    the x-coordinate of the point in client space, relative to the top-left
     *    corner of the canvas
     * @property {number} relativeClientY
     *    the y-coordinate of the point in client space, relative to the top-left
     *    corner of the canvas
     */
    /**
     * @param {ClientPoint} point the point to transform in client space
     * @param {View} view the view transform to apply (defaults to the current view)
     * @returns {ViewPoint} the result of converting the given client coordinate
     * to view space. If there is no canvas set, a top-left corner of (0, 0) is
     * assumed.
     */
    g(this, "clientPointToViewPoint", ({ clientX: r, clientY: e }, n = this._view) => {
      const { left: o, top: u } = this.canvasRect || yt, l = r - o, f = e - u;
      return {
        x: (l - n.x) / n.scale,
        y: (f - n.y) / n.scale,
        relativeClientX: l,
        relativeClientY: f
      };
    });
    /**
     * @typedef ClientPoint
     * @property {number} clientX
     *    the x-coordinate in client space
     * @property {number} clientY
     *    the y-coordinate in client space
     * @property {number} x
     *    an alias for clientX
     * @property {number} y
     *    an alias for clientY
     * @property {number} relativeX
     *    the x-coordinate in client space, relative to the top-left corner of the
     *    canvas
     * @property {number} relativeY
     *    the y-coordinate in client space, relative to the top-left corner of the
     *    canvas
     */
    /**
     * @param {ViewPoint} point the point to transform in view space
     * @param {number} point.x the point's x-coordinate
     * @param {number} point.y the point's y-coordinate
     * @param {View} view the view transform to apply (defaults to the current view)
     * @returns {ClientPoint} the result of converting the given coordinate to
     * client space. If there is no canvas set, a top-left corner of (0, 0) is
     * assumed.
     */
    g(this, "viewPointToClientPoint", ({ x: r, y: e }, n = this._view) => {
      const { left: o, top: u } = this.canvasRect || yt, l = r * n.scale + n.x, f = e * n.scale + n.y, v = l + o, w = f + u;
      return { clientX: v, clientY: w, relativeX: l, relativeY: f, x: v, y: w };
    });
    /**
     * Adds a new callback function that will be invoked each time the view
     * transform changes.
     * @param {ViewListener} listener the callback to execute.
     */
    g(this, "attachViewChangeListener", (r) => {
      this._viewChangeListeners.add(r);
    });
    this._scaleExtents = r, this._documentSize = e;
  }
  /**
   * @returns {Canvas} the canvas currently associated with this instance.
   */
  get canvas() {
    return this._canvas;
  }
  /**
   * Updates the canvas for this coordinate system and recalculates the view.
   * @param {Canvas} canvas the new canvas to associate with this instance.
   */
  set canvas(r) {
    this._canvas = r, this.setView();
  }
  /**
   * @returns {number} the current zoom factor
   */
  get scale() {
    return this._view.scale;
  }
  /**
   * @returns {number} the horizontal component of the current pan offset
   */
  get x() {
    return this._view.x;
  }
  /**
   * Sets the horizontal pan offset (clamped by the document extents) and
   * updates the view.
   * @param {number} x the new offset
   */
  set x(r) {
    this.setView({ x: r });
  }
  /**
   * @retruns {number} the vertical component of the current pan offset
   */
  get y() {
    return this._view.y;
  }
  /**
   * Sets the vertical pan offset (clamped by the document extents) and
   * updates the view.
   * @param {number} y the new offset
   */
  set y(r) {
    this.setView({ y: r });
  }
  /**
   * @returns {View} a copy of this instance's current view state.
   */
  get view() {
    return { ...this._view };
  }
  /**
   * @returns {Extents} a copy of the scale extents currently applied to this
   * instance.
   */
  get scaleExtents() {
    return { ...this._scaleExtents };
  }
  /**
   * Updates the minimum and maximum scale and resets the view transform if it
   * is outside the new extents.
   * @param {Extents} extents the new scale extents.
   */
  set scaleExtents({ min: r, max: e }) {
    this._scaleExtents = { min: r, max: e }, this.setView();
  }
  /**
   * @returns {Size} the current document size (used to constrain the pan
   * offset).
   */
  get documentSize() {
    return { ...this._documentSize };
  }
  /**
   * Sets the document size and recalculates the view if it is outside the new
   * bounds.
   * @param {Size} size the new document size.
   */
  set documentSize({ width: r, height: e }) {
    this._documentSize = { width: r, height: e }, this.setView();
  }
  /**
   * A view matrix expressing a series of transformations.
   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setTransform
   * @typedef Matrix
   * @property {number} a horizontal scaling factor (1 == unscaled)
   * @property {number} b vertical skewing factor (0 == unskewed)
   * @property {number} c horizontal skewing factor (0 == unskewed)
   * @property {number} d vertical scaling factor (1 == unscaled)
   * @property {number} e horizontal translation (0 == untranslated)
   * @property {number} f vertical translation (0 == untranslated)
   */
  /**
   * @returns {Matrix} this coordinate system's current transformation matrix
   */
  get transformMatrix() {
    return {
      a: this._view.scale,
      // horizontal scaling
      b: 0,
      // vertical skewing
      c: 0,
      // horizontal skewing
      d: this._view.scale,
      // vertical scaling
      e: this._view.x,
      f: this._view.y
    };
  }
  /**
   * An object expressing the bounds of a canvas object in terms of the
   * coordinate system.
   * @typedef CanvasBounds
   * @property {number} left the left edge of the canvas in client space
   * @property {number} right the right edge of the canvas in client space
   * @property {number} top the top edge of the canvas in client space
   * @property {number} bottom the bottom edge of the canvas in client space
   * @property {number} canvasWidth the width of the canvas in client space
   * @property {number} canvasHeight the height of the canvas in client space
   * @property {ViewPoint} viewMin the top-left corner of the canvas in view space
   * @property {ViewPoint} viewMax the bottom-right corner of the canvas in view space
   */
  /**
   * @returns {CanvasBounds | undefined} the boundaries of the canvas linked to
   * this coordinate system, or undefined if no canvas is set.
   */
  get canvasBounds() {
    if (this._canvas) {
      const { left: r, top: e, right: n, bottom: o } = this._canvas.getBoundingClientRect();
      return {
        viewMin: this.clientPointToViewPoint({ clientX: r, clientY: e }),
        viewMax: this.clientPointToViewPoint({ clientX: n, clientY: o }),
        left: r,
        top: e,
        right: n,
        bottom: o,
        canvasWidth: this._canvas.width,
        canvasHeight: this._canvas.height
      };
    } else
      return;
  }
  /**
   * @private
   * @return {{left: number, top: number} | undefined}
   */
  get canvasRect() {
    if (this.canvas)
      return this.canvas.getBoundingClientRect();
  }
}
function aa({ ctx: i, img: r, x: e, y: n, w: o, h: u, offsetX: l, offsetY: f } = {}) {
  typeof e != "number" && (e = 0), typeof n != "number" && (n = 0), typeof o != "number" && (o = i.canvas.width), typeof u != "number" && (u = i.canvas.height), typeof l != "number" && (l = 0.5), typeof f != "number" && (f = 0.5), l < 0 && (l = 0), f < 0 && (f = 0), l > 1 && (l = 1), f > 1 && (f = 1);
  var v = r.width, w = r.height, b = Math.min(o / v, u / w), T = v * b, I = w * b, j, F, z, W, B = 1;
  T < o && (B = o / T), Math.abs(B - 1) < 1e-14 && I < u && (B = u / I), T *= B, I *= B, z = v / (T / o), W = w / (I / u), j = (v - z) * l, F = (w - W) * f, j < 0 && (j = 0), F < 0 && (F = 0), z > v && (z = v), W > w && (W = w), i.drawImage(r, j, F, z, W, e, n, o, u);
}
const _t = 10, oa = 250, Oe = (i) => {
  i.preventDefault();
};
class te {
  constructor() {
    g(this, "handleMouseWheel", (r, e) => {
      const { disabled: n, enablePanAndZoom: o, mouseZoomFactor: u } = e.props;
      return n ? new Ue() : (o && r.ctrlKey && (r.preventDefault(), e.coordSystem.scaleAtClientPoint(u * r.deltaY, _e(r))), this);
    });
    g(this, "handleDrawStart", (r, e) => e.props.disabled ? new Ue() : r.ctrlKey && e.props.enablePanAndZoom ? new sa().handleDrawStart(r, e) : new ua().handleDrawStart(r, e));
    g(this, "handleDrawMove", (r, e) => {
      if (e.props.disabled)
        return new Ue();
      {
        const { x: n, y: o } = wt(e.coordSystem, r);
        return e.lazy.update({ x: n, y: o }), this;
      }
    });
    g(this, "handleDrawEnd", (r, e) => e.props.disabled ? new Ue() : this);
  }
}
class Ue {
  constructor() {
    g(this, "handleMouseWheel", (r, e) => e.props.disabled ? this : new te().handleMouseWheel(r, e));
    g(this, "handleDrawStart", (r, e) => e.props.disabled ? this : new te().handleDrawStart(r, e));
    g(this, "handleDrawMove", (r, e) => e.props.disabled ? this : new te().handleDrawMove(r, e));
    g(this, "handleDrawEnd", (r, e) => e.props.disabled ? this : new te().handleDrawEnd(r, e));
  }
}
class sa {
  constructor() {
    g(this, "handleMouseWheel", Oe.bind(this));
    g(this, "handleDrawStart", (r, e) => (r.preventDefault(), this.dragStart = _e(r), this.panStart = { x: e.coordSystem.x, y: e.coordSystem.y }, this));
    g(this, "handleDrawMove", (r, e) => {
      r.preventDefault();
      const { clientX: n, clientY: o } = _e(r), u = n - this.dragStart.clientX, l = o - this.dragStart.clientY;
      return e.coordSystem.setView({ x: this.panStart.x + u, y: this.panStart.y + l }), this;
    });
    g(this, "handleDrawEnd", () => new te());
  }
}
class ua {
  constructor() {
    g(this, "handleMouseWheel", Oe.bind(this));
    g(this, "handleDrawStart", (r, e) => {
      const { enablePanAndZoom: n } = e.props;
      return r.preventDefault(), !r.touches || !r.touches.length || !n ? new Pr().handleDrawStart(r, e) : n && r.touches && r.touches.length >= 2 ? new Or().handleDrawStart(r, e) : this.handleDrawMove(r, e);
    });
    g(this, "handleDrawMove", (r, e) => {
      if (r.preventDefault(), r.touches && r.touches.length >= 2)
        return new Or().handleDrawStart(r, e);
      const n = _e(r);
      return this.deferredPoints.push(n), (/* @__PURE__ */ new Date()).valueOf() - this.startTimestamp < oa && (this.startClientPoint === null && (this.startClientPoint = n), Math.abs(n.clientX - this.startClientPoint.clientX) + Math.abs(n.clientY - this.startClientPoint.clientY) < _t) ? this : this.issueDeferredPoints(e);
    });
    g(this, "handleDrawEnd", (r, e) => this.issueDeferredPoints(e).handleDrawEnd(r, e));
    g(this, "issueDeferredPoints", (r) => {
      let e = new Pr();
      for (let n = 0; n < this.deferredPoints.length; n++) {
        const o = this.deferredPoints[n], u = new fa(o);
        e = (n === 0 ? e.handleDrawStart : e.handleDrawMove)(u, r);
      }
      return e;
    });
    this.startClientPoint = null, this.startTimestamp = (/* @__PURE__ */ new Date()).valueOf(), this.deferredPoints = [];
  }
}
class Or {
  constructor() {
    g(this, "handleMouseWheel", Oe.bind(this));
    g(this, "handleDrawStart", (r, e) => (r.preventDefault(), !r.touches || r.touches.length < 2 ? new te() : (this.start = this.getTouchMetrics(r), this.panStart = { x: e.coordSystem.x, y: e.coordSystem.y }, this.scaleStart = e.coordSystem.scale, this)));
    g(this, "handleDrawMove", (r, e) => {
      if (r.preventDefault(), !r.touches || r.touches.length < 2)
        return new te();
      const { centroid: n, distance: o } = this.recentMetrics = this.getTouchMetrics(r);
      if (Math.abs(o - this.start.distance) >= _t)
        return new la(this).handleDrawMove(r, e);
      const l = n.clientX - this.start.centroid.clientX, f = n.clientY - this.start.centroid.clientY;
      return Math.abs(l) + Math.abs(f) >= _t ? new ca(this).handleDrawMove(r, e) : this;
    });
    g(this, "handleDrawEnd", () => new te());
    g(this, "getTouchMetrics", (r) => {
      const { clientX: e, clientY: n } = _e(r.touches[0]), { clientX: o, clientY: u } = _e(r.touches[1]), l = o - e, f = u - n;
      return {
        t1: { clientX: e, clientY: n },
        t2: { clientX: o, clientY: u },
        distance: Math.sqrt(l * l + f * f),
        centroid: { clientX: (e + o) / 2, clientY: (n + u) / 2 }
      };
    });
  }
}
class ca {
  constructor(r) {
    g(this, "handleMouseWheel", Oe.bind(this));
    g(this, "handleDrawStart", () => this);
    g(this, "handleDrawMove", (r, e) => {
      if (r.preventDefault(), !r.touches || r.touches.length < 2)
        return new te();
      const n = this.scaleOrPanState, { centroid: o, distance: u } = n.recentMetrics = n.getTouchMetrics(r), l = o.clientX - n.start.centroid.clientX, f = o.clientY - n.start.centroid.clientY;
      return e.setView({ x: n.panStart.x + l, y: n.panStart.y + f }), this;
    });
    g(this, "handleDrawEnd", () => new te());
    this.scaleOrPanState = r;
  }
}
class la {
  constructor(r) {
    g(this, "handleMouseWheel", Oe.bind(this));
    g(this, "handleDrawStart", () => this);
    g(this, "handleDrawMove", (r, e) => {
      if (r.preventDefault(), !r.touches || r.touches.length < 2)
        return new te();
      const n = this.scaleOrPanState, { centroid: o, distance: u } = n.recentMetrics = n.getTouchMetrics(r), f = n.scaleStart * (u / n.start.distance) - e.coordSystem.scale;
      return e.coordSystem.scaleAtClientPoint(f, o), this;
    });
    g(this, "handleDrawEnd", () => new te());
    this.scaleOrPanState = r;
  }
}
class Pr {
  constructor() {
    g(this, "handleMouseWheel", Oe.bind(this));
    g(this, "handleDrawStart", (r, e) => {
      if (r.preventDefault(), r.touches && r.touches.length) {
        const { x: n, y: o } = wt(e.coordSystem, r);
        e.lazy.update({ x: n, y: o }, { both: !0 });
      }
      return this.handleDrawMove(r, e);
    });
    g(this, "handleDrawMove", (r, e) => {
      r.preventDefault();
      const { x: n, y: o } = wt(e.coordSystem, r);
      e.lazy.update({ x: n, y: o });
      const u = !e.lazy.isEnabled(), l = e.props.erase ? { ...e.lazy.brush.toObject(), erase: !0 } : e.lazy.brush.toObject();
      return (!this.isDrawing || u) && (e.points.push(e.clampPointToDocument(l)), this.isDrawing = !0), e.points.push(e.clampPointToDocument(l)), e.drawPoints({
        points: e.points,
        brushColor: l.erase ? "erase" : e.props.brushColor,
        brushRadius: e.props.brushRadius
      }), this;
    });
    g(this, "handleDrawEnd", (r, e) => (r.preventDefault(), this.handleDrawMove(r, e), e.saveLine(), new te()));
    this.isDrawing = !1;
  }
}
class fa {
  constructor({ clientX: r, clientY: e }) {
    g(this, "preventDefault", () => {
    });
    this.clientX = r, this.clientY = e, this.touches = [{ clientX: r, clientY: e }];
  }
}
function _e(i) {
  let r = i.clientX, e = i.clientY;
  return i.changedTouches && i.changedTouches.length > 0 && (r = i.changedTouches[0].clientX, e = i.changedTouches[0].clientY), { clientX: r, clientY: e };
}
function wt(i, r) {
  return i.clientPointToViewPoint(_e(r));
}
let Et = !1;
try {
  const i = {
    get passive() {
      return Et = !0, !1;
    }
  };
  window.addEventListener("test", i, i), window.removeEventListener("test", i, i);
} catch {
  Et = !1;
}
function ha(i) {
  return Et ? { passive: i } : i;
}
function da(i, r) {
  return {
    x: i.x + (r.x - i.x) / 2,
    y: i.y + (r.y - i.y) / 2
  };
}
const pa = {
  display: "block",
  position: "absolute"
}, xr = ["grid", "drawing", "temp", "interface"], Mr = U.oneOfType([U.number, U.string]), va = U.shape({
  min: U.number.isRequired,
  max: U.number.isRequired
});
class Dr extends Ar.PureComponent {
  ///// public API /////////////////////////////////////////////////////////////
  constructor(e) {
    super(e);
    g(this, "undo", () => {
      let e = [];
      this.lines.length ? e = this.lines.slice(0, -1) : this.erasedLines.length && (e = this.erasedLines.pop()), this.clearExceptErasedLines(), this.simulateDrawingLines({ lines: e, immediate: !0 }), this.triggerOnChange();
    });
    g(this, "eraseAll", () => {
      this.erasedLines.push([...this.lines]), this.clearExceptErasedLines(), this.triggerOnChange();
    });
    g(this, "clear", () => {
      this.erasedLines = [], this.clearExceptErasedLines(), this.resetView();
    });
    g(this, "resetView", () => this.coordSystem.resetView());
    g(this, "setView", (e) => this.coordSystem.setView(e));
    g(this, "getSaveData", () => JSON.stringify({
      lines: this.lines,
      width: this.props.canvasWidth,
      height: this.props.canvasHeight
    }));
    /**
       * Combination of work by Ernie Arrowsmith and emizz
       * References:
       * https://stackoverflow.com/questions/32160098/change-html-canvas-black-background-to-white-background-when-creating-jpg-image
       * https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toDataURL
    
       * This function will export the canvas to a data URL, which can subsequently be used to share or manipulate the image file.
       * @param {string} fileType Specifies the file format to export to. Note: should only be the file type, not the "image/" prefix.
       *  For supported types see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toDataURL
       * @param {bool} useBgImage Specifies whether the canvas' current background image should also be exported. Default is false.
       * @param {string} backgroundColour The desired background colour hex code, e.g. "#ffffff" for white.
       */
    g(this, "getDataURL", (e, n, o) => {
      let u = this.canvas.drawing, l = u.getContext("2d"), f = u.width, v = u.height, w = l.getImageData(0, 0, f, v);
      var b = l.globalCompositeOperation;
      if (l.globalCompositeOperation = "destination-over", n) {
        if (!this.props.imgSrc) return "Background image source not set";
        this.drawImage();
      } else o != null && (l.fillStyle = o, l.fillRect(0, 0, f, v));
      e || (e = "png");
      let T = u.toDataURL(`image/${e}`);
      return l.clearRect(0, 0, f, v), l.putImageData(w, 0, 0), l.globalCompositeOperation = b, T;
    });
    g(this, "loadSaveData", (e, n = this.props.immediateLoading) => {
      if (typeof e != "string")
        throw new Error("saveData needs to be of type string!");
      const { lines: o, width: u, height: l } = JSON.parse(e);
      if (!o || typeof o.push != "function")
        throw new Error("saveData.lines needs to be an array!");
      if (this.clear(), u === this.props.canvasWidth && l === this.props.canvasHeight)
        this.simulateDrawingLines({
          lines: o,
          immediate: n
        });
      else {
        const f = this.props.canvasWidth / u, v = this.props.canvasHeight / l, w = (f + v) / 2;
        this.simulateDrawingLines({
          lines: o.map((b) => ({
            ...b,
            points: b.points.map((T) => ({
              x: T.x * f,
              y: T.y * v
            })),
            brushRadius: b.brushRadius * w
          })),
          immediate: n
        });
      }
    });
    g(this, "componentWillUnmount", () => {
      this.canvasObserver.unobserve(this.canvasContainer), this.canvas.interface && this.canvas.interface.removeEventListener("wheel", this.handleWheel);
    });
    ///// Event Handlers
    g(this, "handleWheel", (e) => {
      this.interactionSM || (this.interactionSM = new te()), this.interactionSM = this.interactionSM.handleMouseWheel(e, this);
    });
    g(this, "handleDrawStart", (e) => {
      this.interactionSM || (this.interactionSM = new te()), this.interactionSM = this.interactionSM.handleDrawStart(e, this), this.mouseHasMoved = !0;
    });
    g(this, "handleDrawMove", (e) => {
      this.interactionSM || (this.interactionSM = new te()), this.interactionSM = this.interactionSM.handleDrawMove(e, this), this.mouseHasMoved = !0;
    });
    g(this, "handleDrawEnd", (e) => {
      this.interactionSM || (this.interactionSM = new te()), this.interactionSM = this.interactionSM.handleDrawEnd(e, this), this.mouseHasMoved = !0;
    });
    g(this, "applyView", () => {
      if (this.ctx.drawing && (xr.map((e) => this.ctx[e]).forEach((e) => {
        this.clearWindow(e);
        const n = this.coordSystem.transformMatrix;
        e.setTransform(n.a, n.b, n.c, n.d, n.e, n.f);
      }), !this.deferRedrawOnViewChange)) {
        this.drawGrid(this.ctx.grid), this.redrawImage(), this.loop({ once: !0 });
        const e = this.lines;
        this.lines = [], this.simulateDrawingLines({ lines: e, immediate: !0 });
      }
    });
    g(this, "handleCanvasResize", (e) => {
      const n = this.getSaveData();
      this.deferRedrawOnViewChange = !0;
      try {
        for (const o of e) {
          const { width: u, height: l } = o.contentRect;
          this.setCanvasSize(this.canvas.interface, u, l), this.setCanvasSize(this.canvas.drawing, u, l), this.setCanvasSize(this.canvas.temp, u, l), this.setCanvasSize(this.canvas.grid, u, l), this.coordSystem.documentSize = { width: u, height: l }, this.drawGrid(this.ctx.grid), this.drawImage(), this.loop({ once: !0 });
        }
        this.loadSaveData(n, !0);
      } finally {
        this.deferRedrawOnViewChange = !1;
      }
    });
    ///// Helpers
    g(this, "clampPointToDocument", (e) => this.props.clampLinesToDocument ? {
      x: Math.max(Math.min(e.x, this.props.canvasWidth), 0),
      y: Math.max(Math.min(e.y, this.props.canvasHeight), 0)
    } : e);
    g(this, "redrawImage", () => {
      this.image && this.image.complete && aa({ ctx: this.ctx.grid, img: this.image });
    });
    g(this, "simulateDrawingLines", ({ lines: e, immediate: n }) => {
      let o = 0, u = n ? 0 : this.props.loadTimeOffset;
      e.forEach((l) => {
        const { points: f, brushColor: v, brushRadius: w } = l;
        if (n) {
          this.drawPoints({
            points: f,
            brushColor: v,
            brushRadius: w
          }), this.points = f, this.saveLine({ brushColor: v, brushRadius: w });
          return;
        }
        for (let b = 1; b < f.length; b++)
          o += u, window.setTimeout(() => {
            this.drawPoints({
              points: f.slice(0, b + 1),
              brushColor: v,
              brushRadius: w
            });
          }, o);
        o += u, window.setTimeout(() => {
          this.points = f, this.saveLine({ brushColor: v, brushRadius: w });
        }, o);
      });
    });
    g(this, "setCanvasSize", (e, n, o) => {
      e.width = n, e.height = o, e.style.width = n, e.style.height = o;
    });
    g(this, "drawPoints", ({ points: e, brushColor: n, brushRadius: o }) => {
      this.ctx.temp.lineJoin = "round", this.ctx.temp.lineCap = "round", this.ctx.temp.strokeStyle = n === "erase" ? this.props.eraseColor : n, this.ctx.drawing.globalCompositeOperation = n === "erase" ? "destination-out" : "xor", this.clearWindow(this.ctx.temp), this.ctx.temp.lineWidth = o * 2;
      let u = e[0], l = e[1];
      this.ctx.temp.moveTo(l.x, l.y), this.ctx.temp.beginPath();
      for (var f = 1, v = e.length; f < v; f++) {
        var w = da(u, l);
        this.ctx.temp.quadraticCurveTo(u.x, u.y, w.x, w.y), u = e[f], l = e[f + 1];
      }
      this.ctx.temp.lineTo(u.x, u.y), this.ctx.temp.stroke();
    });
    g(this, "saveLine", ({ brushColor: e, brushRadius: n } = {}) => {
      this.points.length < 2 || (this.points[0].erase && (e = "erase"), this.lines.push({
        points: [...this.points],
        brushColor: e || this.props.brushColor,
        brushRadius: n || this.props.brushRadius
      }), this.points.length = 0, this.inClientSpace([this.ctx.drawing, this.ctx.temp], () => {
        this.ctx.drawing.drawImage(
          this.canvas.temp,
          0,
          0,
          this.canvas.drawing.width,
          this.canvas.drawing.height
        );
      }), this.clearWindow(this.ctx.temp), this.triggerOnChange());
    });
    g(this, "triggerOnChange", () => {
      this.props.onChange && this.props.onChange(this);
    });
    g(this, "clearWindow", (e) => {
      this.inClientSpace([e], () => e.clearRect(0, 0, e.canvas.width, e.canvas.height));
    });
    g(this, "clearExceptErasedLines", () => {
      this.lines = [], this.valuesChanged = !0, this.clearWindow(this.ctx.drawing), this.clearWindow(this.ctx.temp);
    });
    g(this, "loop", ({ once: e = !1 } = {}) => {
      if (this.mouseHasMoved || this.valuesChanged) {
        const n = this.lazy.getPointerCoordinates(), o = this.lazy.getBrushCoordinates();
        this.drawInterface(this.ctx.interface, n, o), this.mouseHasMoved = !1, this.valuesChanged = !1;
      }
      e || window.requestAnimationFrame(() => {
        this.loop();
      });
    });
    g(this, "inClientSpace", (e, n) => {
      e.forEach((o) => {
        o.save(), o.setTransform(Re.a, Re.b, Re.c, Re.d, Re.e, Re.f);
      });
      try {
        n();
      } finally {
        e.forEach((o) => o.restore());
      }
    });
    ///// Canvas Rendering
    g(this, "drawImage", () => {
      this.props.imgSrc && (this.image = new Image(), this.image.onload = this.redrawImage, this.image.src = this.props.imgSrc);
    });
    g(this, "drawGrid", (e) => {
      if (this.props.hideGrid) return;
      this.clearWindow(e);
      const n = 25, { viewMin: o, viewMax: u } = this.coordSystem.canvasBounds, l = Math.floor(o.x / n - 1) * n, f = Math.floor(o.y / n - 1) * n, v = u.x + n, w = u.y + n;
      if (e.beginPath(), e.setLineDash([5, 1]), e.setLineDash([]), e.strokeStyle = this.props.gridColor, e.lineWidth = this.props.gridLineWidth, !this.props.hideGridX) {
        let b = l;
        const T = this.props.gridSizeX;
        for (; b < v; )
          b += T, e.moveTo(b, f), e.lineTo(b, w);
        e.stroke();
      }
      if (!this.props.hideGridY) {
        let b = f;
        const T = this.props.gridSizeY;
        for (; b < w; )
          b += T, e.moveTo(l, b), e.lineTo(v, b);
        e.stroke();
      }
    });
    g(this, "drawInterface", (e, n, o) => {
      if (this.props.hideInterface) return;
      this.clearWindow(e);
      const u = this.props.eraseColor.length === 7 ? this.props.eraseColor + "90" : this.props.eraseColor, l = this.props.erase ? u : this.props.brushColor;
      e.beginPath(), e.fillStyle = l, e.arc(o.x, o.y, this.props.brushRadius, 0, Math.PI * 2, !0), e.fill(), e.beginPath(), e.fillStyle = this.props.catenaryColor, e.arc(n.x, n.y, 4, 0, Math.PI * 2, !0), e.fill(), this.lazy.isEnabled() && (e.beginPath(), e.lineWidth = 2, e.lineCap = "round", e.setLineDash([2, 4]), e.strokeStyle = this.props.catenaryColor, this.catenary.drawToCanvas(this.ctx.interface, o, n, this.chainLength), e.stroke()), e.beginPath(), e.fillStyle = this.props.catenaryColor, e.arc(o.x, o.y, 2, 0, Math.PI * 2, !0), e.fill();
    });
    this.canvas = {}, this.ctx = {}, this.catenary = new $r(), this.points = [], this.lines = [], this.erasedLines = [], this.mouseHasMoved = !0, this.valuesChanged = !0, this.isDrawing = !1, this.isPressing = !1, this.deferRedrawOnViewChange = !1, this.interactionSM = new te(), this.coordSystem = new ia({
      scaleExtents: e.zoomExtents,
      documentSize: { width: e.canvasWidth, height: e.canvasHeight }
    }), this.coordSystem.attachViewChangeListener(this.applyView.bind(this));
  }
  ///// private API ////////////////////////////////////////////////////////////
  ///// React Lifecycle
  componentDidMount() {
    this.lazy = new jr({
      radius: this.props.lazyRadius * window.devicePixelRatio,
      enabled: !0,
      initialPoint: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      }
    }), this.chainLength = this.props.lazyRadius * window.devicePixelRatio, this.canvasObserver = new na(
      (e, n) => this.handleCanvasResize(e, n)
    ), this.canvasObserver.observe(this.canvasContainer), this.drawImage(), this.loop(), window.setTimeout(() => {
      const e = window.innerWidth / 2, n = window.innerHeight / 2;
      this.lazy.update({ x: e - this.chainLength / 4, y: n }, { both: !0 }), this.lazy.update({ x: e + this.chainLength / 4, y: n }, { both: !1 }), this.mouseHasMoved = !0, this.valuesChanged = !0, this.clearExceptErasedLines(), this.props.saveData && this.loadSaveData(this.props.saveData);
    }, 100), this.canvas.interface && this.canvas.interface.addEventListener("wheel", this.handleWheel, ha());
  }
  componentDidUpdate(e) {
    e.lazyRadius !== this.props.lazyRadius && (this.chainLength = this.props.lazyRadius * window.devicePixelRatio, this.lazy.setRadius(this.props.lazyRadius * window.devicePixelRatio)), e.saveData !== this.props.saveData && this.loadSaveData(this.props.saveData), JSON.stringify(e) !== JSON.stringify(this.props) && (this.valuesChanged = !0), this.coordSystem.scaleExtents = this.props.zoomExtents, this.props.enablePanAndZoom || this.coordSystem.resetView(), e.imgSrc !== this.props.imgSrc && this.drawImage();
  }
  render() {
    return /* @__PURE__ */ hr.createElement(
      "div",
      {
        className: this.props.className,
        style: {
          display: "block",
          background: this.props.backgroundColor,
          touchAction: "none",
          width: this.props.canvasWidth,
          height: this.props.canvasHeight,
          ...this.props.style
        },
        ref: (e) => {
          e && (this.canvasContainer = e);
        }
      },
      xr.map((e) => {
        const n = e === "interface";
        return /* @__PURE__ */ hr.createElement(
          "canvas",
          {
            key: e,
            ref: (o) => {
              o && (this.canvas[e] = o, this.ctx[e] = o.getContext("2d"), n && (this.coordSystem.canvas = o));
            },
            style: { ...pa },
            onMouseDown: n ? this.handleDrawStart : void 0,
            onMouseMove: n ? this.handleDrawMove : void 0,
            onMouseUp: n ? this.handleDrawEnd : void 0,
            onMouseOut: n ? this.handleDrawEnd : void 0,
            onTouchStart: n ? this.handleDrawStart : void 0,
            onTouchMove: n ? this.handleDrawMove : void 0,
            onTouchEnd: n ? this.handleDrawEnd : void 0,
            onTouchCancel: n ? this.handleDrawEnd : void 0
          }
        );
      })
    );
  }
}
g(Dr, "propTypes", {
  onChange: U.func,
  loadTimeOffset: U.number,
  lazyRadius: U.number,
  brushRadius: U.number,
  brushColor: U.string,
  catenaryColor: U.string,
  gridColor: U.string,
  backgroundColor: U.string,
  hideGrid: U.bool,
  canvasWidth: Mr,
  canvasHeight: Mr,
  disabled: U.bool,
  imgSrc: U.string,
  saveData: U.string,
  immediateLoading: U.bool,
  hideInterface: U.bool,
  erase: U.bool,
  eraseColor: U.string,
  gridSizeX: U.number,
  gridSizeY: U.number,
  gridLineWidth: U.number,
  hideGridX: U.bool,
  hideGridY: U.bool,
  enablePanAndZoom: U.bool,
  mouseZoomFactor: U.number,
  zoomExtents: va,
  clampLinesToDocument: U.bool
}), g(Dr, "defaultProps", {
  onChange: null,
  loadTimeOffset: 5,
  lazyRadius: 12,
  brushRadius: 10,
  brushColor: "#444",
  catenaryColor: "#0a0302",
  gridColor: "rgba(150,150,150,0.17)",
  backgroundColor: "#FFF",
  hideGrid: !1,
  canvasWidth: 400,
  canvasHeight: 400,
  disabled: !1,
  imgSrc: "",
  saveData: "",
  immediateLoading: !1,
  hideInterface: !1,
  erase: !1,
  eraseColor: "#fcf2f2",
  gridSizeX: 25,
  gridSizeY: 25,
  gridLineWidth: 0.5,
  hideGridX: !1,
  hideGridY: !1,
  enablePanAndZoom: !1,
  mouseZoomFactor: 0.01,
  zoomExtents: { min: 0.33, max: 3 },
  clampLinesToDocument: !1
});
export {
  Dr as default
};
